var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _path2, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _path3, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _path4, _g57, _g58, _g59, _g60, _g61, _g62, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBetLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1416,
    height: 1525,
    viewBox: "0 0 1416 1525",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M268.712 1230.36C267.609 1230.36 266.68 1229.99 265.926 1229.23C265.172 1228.48 264.794 1227.55 264.794 1226.45V1176.57H247.037C245.992 1176.57 245.122 1176.22 244.425 1175.53C243.729 1174.83 243.381 1173.96 243.381 1172.91C243.381 1171.87 243.729 1171 244.425 1170.3C245.122 1169.55 245.992 1169.17 247.037 1169.17H290.386C291.431 1169.17 292.301 1169.55 292.998 1170.3C293.752 1171 294.129 1171.87 294.129 1172.91C294.129 1173.96 293.752 1174.83 292.998 1175.53C292.301 1176.22 291.431 1176.57 290.386 1176.57H272.716V1226.45C272.716 1227.55 272.309 1228.48 271.497 1229.23C270.743 1229.99 269.814 1230.36 268.712 1230.36ZM300.902 1230.36C299.799 1230.36 298.871 1229.99 298.116 1229.23C297.362 1228.48 296.985 1227.55 296.985 1226.45V1189.1C296.985 1188 297.362 1187.07 298.116 1186.32C298.871 1185.51 299.799 1185.1 300.902 1185.1C302.005 1185.1 302.933 1185.51 303.687 1186.32C304.5 1187.07 304.906 1188 304.906 1189.1V1192.85C308.968 1187.39 313.524 1184.67 318.573 1184.67H319.008C320.11 1184.67 321.01 1185.04 321.706 1185.8C322.461 1186.55 322.838 1187.48 322.838 1188.58C322.838 1189.68 322.461 1190.58 321.706 1191.28C320.952 1191.98 319.994 1192.33 318.834 1192.33H318.398C315.613 1192.33 313.06 1193.02 310.738 1194.41C308.417 1195.75 306.473 1197.61 304.906 1199.99V1226.45C304.906 1227.55 304.5 1228.48 303.687 1229.23C302.933 1229.99 302.005 1230.36 300.902 1230.36ZM341.624 1230.8C339.07 1230.8 336.691 1230.28 334.486 1229.23C332.339 1228.19 330.627 1226.68 329.35 1224.71C328.073 1222.68 327.435 1220.35 327.435 1217.74C327.435 1213.45 329.118 1210.02 332.484 1207.47C335.908 1204.92 340.898 1203.64 347.456 1203.64H357.989V1202.95C357.989 1199.12 357.031 1196.36 355.116 1194.68C353.259 1192.99 350.328 1192.15 346.324 1192.15C344.119 1192.15 342.146 1192.33 340.405 1192.67C338.722 1193.02 336.836 1193.54 334.747 1194.24C334.283 1194.36 333.906 1194.41 333.615 1194.41C332.745 1194.41 331.99 1194.1 331.352 1193.46C330.714 1192.82 330.395 1192.04 330.395 1191.11C330.395 1189.54 331.149 1188.44 332.658 1187.8C337.591 1185.71 342.61 1184.67 347.717 1184.67C351.721 1184.67 355.087 1185.48 357.814 1187.1C360.6 1188.73 362.631 1190.85 363.908 1193.46C365.242 1196.01 365.91 1198.8 365.91 1201.81V1226.45C365.91 1227.55 365.504 1228.48 364.691 1229.23C363.937 1229.99 363.008 1230.36 361.906 1230.36C360.803 1230.36 359.875 1229.99 359.12 1229.23C358.366 1228.48 357.989 1227.55 357.989 1226.45V1224.18C353.694 1228.59 348.239 1230.8 341.624 1230.8ZM344.583 1223.84C347.137 1223.84 349.603 1223.23 351.982 1222.01C354.362 1220.73 356.364 1219.16 357.989 1217.31V1210H348.5C339.738 1210 335.356 1212.29 335.356 1216.87C335.356 1218.96 336.053 1220.64 337.445 1221.92C338.896 1223.2 341.276 1223.84 344.583 1223.84ZM397.554 1230.8C393.956 1230.8 390.532 1229.9 387.282 1228.1C384.09 1226.24 381.479 1223.58 379.448 1220.09C377.475 1216.55 376.488 1212.43 376.488 1207.73C376.488 1203.03 377.475 1198.94 379.448 1195.46C381.479 1191.92 384.09 1189.25 387.282 1187.45C390.532 1185.59 393.956 1184.67 397.554 1184.67C403.241 1184.67 408.202 1186.87 412.439 1191.28V1169.95C412.439 1168.79 412.816 1167.84 413.57 1167.08C414.383 1166.33 415.34 1165.95 416.443 1165.95C417.545 1165.95 418.474 1166.36 419.228 1167.17C419.983 1167.92 420.36 1168.85 420.36 1169.95V1226.45C420.36 1227.55 419.983 1228.48 419.228 1229.23C418.474 1229.99 417.545 1230.36 416.443 1230.36C415.34 1230.36 414.383 1229.99 413.57 1229.23C412.816 1228.48 412.439 1227.55 412.439 1226.45V1224.18C408.202 1228.59 403.241 1230.8 397.554 1230.8ZM398.685 1223.4C401.355 1223.4 403.85 1222.82 406.171 1221.66C408.55 1220.44 410.64 1218.85 412.439 1216.87V1198.59C410.64 1196.62 408.55 1195.05 406.171 1193.89C403.85 1192.67 401.355 1192.06 398.685 1192.06C394.391 1192.06 390.938 1193.43 388.327 1196.16C385.715 1198.88 384.409 1202.74 384.409 1207.73C384.409 1212.72 385.715 1216.58 388.327 1219.31C390.938 1222.04 394.391 1223.4 398.685 1223.4ZM453.948 1230.8C446.868 1230.8 441.326 1228.8 437.322 1224.79C433.376 1220.73 431.403 1215.04 431.403 1207.73C431.403 1203.61 432.157 1199.81 433.666 1196.33C435.175 1192.85 437.496 1190.03 440.63 1187.89C443.763 1185.74 447.622 1184.67 452.207 1184.67C456.501 1184.67 460.215 1185.68 463.349 1187.71C466.483 1189.68 468.862 1192.35 470.487 1195.72C472.112 1199.03 472.924 1202.65 472.924 1206.6C472.924 1207.7 472.547 1208.63 471.792 1209.39C471.096 1210.14 470.139 1210.52 468.92 1210.52H439.411C439.875 1214.58 441.384 1217.74 443.937 1220.01C446.491 1222.27 450.06 1223.4 454.644 1223.4C457.082 1223.4 459.2 1223.17 460.999 1222.7C462.856 1222.24 464.655 1221.57 466.396 1220.7C466.86 1220.47 467.382 1220.35 467.962 1220.35C468.891 1220.35 469.703 1220.67 470.4 1221.31C471.096 1221.95 471.444 1222.76 471.444 1223.75C471.444 1225.03 470.69 1226.1 469.181 1226.97C466.918 1228.25 464.684 1229.2 462.478 1229.84C460.273 1230.48 457.43 1230.8 453.948 1230.8ZM465.09 1204.08C464.916 1201.23 464.161 1198.85 462.827 1196.94C461.55 1195.02 459.954 1193.63 458.039 1192.76C456.124 1191.83 454.18 1191.37 452.207 1191.37C450.234 1191.37 448.29 1191.83 446.375 1192.76C444.46 1193.63 442.864 1195.02 441.587 1196.94C440.31 1198.85 439.585 1201.23 439.411 1204.08H465.09ZM511.501 1229.93C510.398 1229.93 509.47 1229.55 508.715 1228.8C507.961 1228.04 507.584 1227.12 507.584 1226.01V1173.17C507.584 1172.07 507.961 1171.14 508.715 1170.39C509.47 1169.58 510.398 1169.17 511.501 1169.17H532.044C538.253 1169.17 543.041 1170.59 546.407 1173.44C549.831 1176.28 551.543 1180.11 551.543 1184.93C551.543 1188.29 550.73 1191.11 549.105 1193.37C547.538 1195.58 545.507 1197.23 543.012 1198.33C546.494 1199.43 549.337 1201.2 551.543 1203.64C553.806 1206.08 554.937 1209.15 554.937 1212.87C554.937 1218.21 553.138 1222.39 549.541 1225.4C545.943 1228.42 540.285 1229.93 532.566 1229.93H511.501ZM529.955 1195.46C535.12 1195.46 538.747 1194.59 540.836 1192.85C542.925 1191.11 543.97 1188.67 543.97 1185.54C543.97 1182.81 542.838 1180.63 540.575 1179.01C538.369 1177.38 535.323 1176.57 531.435 1176.57H515.505V1195.46H529.955ZM531.783 1222.53C537.412 1222.53 541.387 1221.66 543.708 1219.92C546.088 1218.18 547.277 1215.71 547.277 1212.52C547.277 1205.9 542.142 1202.6 531.87 1202.6H515.505V1222.53H531.783ZM585.794 1230.8C578.714 1230.8 573.172 1228.8 569.168 1224.79C565.221 1220.73 563.248 1215.04 563.248 1207.73C563.248 1203.61 564.003 1199.81 565.512 1196.33C567.02 1192.85 569.342 1190.03 572.475 1187.89C575.609 1185.74 579.468 1184.67 584.053 1184.67C588.347 1184.67 592.061 1185.68 595.195 1187.71C598.328 1189.68 600.708 1192.35 602.333 1195.72C603.957 1199.03 604.77 1202.65 604.77 1206.6C604.77 1207.7 604.393 1208.63 603.638 1209.39C602.942 1210.14 601.984 1210.52 600.766 1210.52H571.257C571.721 1214.58 573.23 1217.74 575.783 1220.01C578.337 1222.27 581.905 1223.4 586.49 1223.4C588.927 1223.4 591.045 1223.17 592.844 1222.7C594.701 1222.24 596.5 1221.57 598.241 1220.7C598.706 1220.47 599.228 1220.35 599.808 1220.35C600.737 1220.35 601.549 1220.67 602.246 1221.31C602.942 1221.95 603.29 1222.76 603.29 1223.75C603.29 1225.03 602.536 1226.1 601.027 1226.97C598.764 1228.25 596.529 1229.2 594.324 1229.84C592.119 1230.48 589.275 1230.8 585.794 1230.8ZM596.936 1204.08C596.762 1201.23 596.007 1198.85 594.672 1196.94C593.396 1195.02 591.8 1193.63 589.885 1192.76C587.97 1191.83 586.026 1191.37 584.053 1191.37C582.08 1191.37 580.136 1191.83 578.22 1192.76C576.305 1193.63 574.71 1195.02 573.433 1196.94C572.156 1198.85 571.431 1201.23 571.257 1204.08H596.936ZM630.571 1230.8C622.099 1230.8 617.862 1226.97 617.862 1219.31V1192.33H611.682C611.218 1192.33 610.811 1192.18 610.463 1191.89C610.173 1191.54 610.028 1191.14 610.028 1190.67C610.028 1190.09 610.289 1189.6 610.811 1189.19L622.65 1177.61C623.172 1177.09 623.665 1176.83 624.13 1176.83C624.594 1176.83 624.971 1177.01 625.261 1177.35C625.61 1177.7 625.784 1178.11 625.784 1178.57V1185.54H635.62C636.606 1185.54 637.419 1185.85 638.057 1186.49C638.696 1187.13 639.015 1187.94 639.015 1188.93C639.015 1189.86 638.696 1190.67 638.057 1191.37C637.419 1192.01 636.606 1192.33 635.62 1192.33H625.784V1218.61C625.784 1220.88 626.306 1222.33 627.35 1222.97C628.453 1223.55 629.817 1223.84 631.442 1223.84C632.602 1223.84 633.763 1223.66 634.924 1223.31C635.156 1223.26 635.388 1223.2 635.62 1223.14C635.91 1223.08 636.258 1223.05 636.664 1223.05C637.477 1223.05 638.202 1223.37 638.841 1224.01C639.479 1224.59 639.798 1225.32 639.798 1226.19C639.798 1227.52 639.131 1228.54 637.796 1229.23C635.533 1230.28 633.125 1230.8 630.571 1230.8ZM663.809 1230.8C655.336 1230.8 651.1 1226.97 651.1 1219.31V1192.33H644.92C644.455 1192.33 644.049 1192.18 643.701 1191.89C643.411 1191.54 643.266 1191.14 643.266 1190.67C643.266 1190.09 643.527 1189.6 644.049 1189.19L655.888 1177.61C656.41 1177.09 656.903 1176.83 657.367 1176.83C657.832 1176.83 658.209 1177.01 658.499 1177.35C658.847 1177.7 659.021 1178.11 659.021 1178.57V1185.54H668.858C669.844 1185.54 670.657 1185.85 671.295 1186.49C671.933 1187.13 672.252 1187.94 672.252 1188.93C672.252 1189.86 671.933 1190.67 671.295 1191.37C670.657 1192.01 669.844 1192.33 668.858 1192.33H659.021V1218.61C659.021 1220.88 659.544 1222.33 660.588 1222.97C661.691 1223.55 663.055 1223.84 664.679 1223.84C665.84 1223.84 667.001 1223.66 668.161 1223.31C668.393 1223.26 668.626 1223.2 668.858 1223.14C669.148 1223.08 669.496 1223.05 669.902 1223.05C670.715 1223.05 671.44 1223.37 672.078 1224.01C672.717 1224.59 673.036 1225.32 673.036 1226.19C673.036 1227.52 672.369 1228.54 671.034 1229.23C668.771 1230.28 666.362 1230.8 663.809 1230.8ZM700.978 1230.8C693.898 1230.8 688.356 1228.8 684.352 1224.79C680.406 1220.73 678.433 1215.04 678.433 1207.73C678.433 1203.61 679.187 1199.81 680.696 1196.33C682.205 1192.85 684.526 1190.03 687.66 1187.89C690.794 1185.74 694.653 1184.67 699.237 1184.67C703.531 1184.67 707.245 1185.68 710.379 1187.71C713.513 1189.68 715.892 1192.35 717.517 1195.72C719.142 1199.03 719.954 1202.65 719.954 1206.6C719.954 1207.7 719.577 1208.63 718.823 1209.39C718.126 1210.14 717.169 1210.52 715.95 1210.52H686.441C686.905 1214.58 688.414 1217.74 690.968 1220.01C693.521 1222.27 697.09 1223.4 701.674 1223.4C704.112 1223.4 706.23 1223.17 708.029 1222.7C709.886 1222.24 711.685 1221.57 713.426 1220.7C713.89 1220.47 714.412 1220.35 714.993 1220.35C715.921 1220.35 716.734 1220.67 717.43 1221.31C718.126 1221.95 718.475 1222.76 718.475 1223.75C718.475 1225.03 717.72 1226.1 716.211 1226.97C713.948 1228.25 711.714 1229.2 709.509 1229.84C707.303 1230.48 704.46 1230.8 700.978 1230.8ZM712.12 1204.08C711.946 1201.23 711.192 1198.85 709.857 1196.94C708.58 1195.02 706.984 1193.63 705.069 1192.76C703.154 1191.83 701.21 1191.37 699.237 1191.37C697.264 1191.37 695.32 1191.83 693.405 1192.76C691.49 1193.63 689.894 1195.02 688.617 1196.94C687.341 1198.85 686.615 1201.23 686.441 1204.08H712.12ZM734.352 1230.36C733.25 1230.36 732.321 1229.99 731.567 1229.23C730.813 1228.48 730.435 1227.55 730.435 1226.45V1189.1C730.435 1188 730.813 1187.07 731.567 1186.32C732.321 1185.51 733.25 1185.1 734.352 1185.1C735.455 1185.1 736.384 1185.51 737.138 1186.32C737.95 1187.07 738.357 1188 738.357 1189.1V1192.85C742.419 1187.39 746.974 1184.67 752.023 1184.67H752.458C753.561 1184.67 754.46 1185.04 755.157 1185.8C755.911 1186.55 756.288 1187.48 756.288 1188.58C756.288 1189.68 755.911 1190.58 755.157 1191.28C754.402 1191.98 753.445 1192.33 752.284 1192.33H751.849C749.063 1192.33 746.51 1193.02 744.189 1194.41C741.868 1195.75 739.923 1197.61 738.357 1199.99V1226.45C738.357 1227.55 737.95 1228.48 737.138 1229.23C736.384 1229.99 735.455 1230.36 734.352 1230.36ZM762.254 1243.07C761.558 1243.07 760.949 1242.81 760.426 1242.29C759.962 1241.77 759.73 1241.16 759.73 1240.46C759.73 1239.53 760.165 1238.81 761.036 1238.29C762.487 1237.42 763.589 1236.4 764.344 1235.24C765.098 1234.08 765.475 1232.4 765.475 1230.19H765.127C763.792 1230.19 762.632 1229.73 761.645 1228.8C760.717 1227.81 760.252 1226.65 760.252 1225.32V1224.79C760.252 1223.46 760.717 1222.33 761.645 1221.4C762.632 1220.41 763.792 1219.92 765.127 1219.92H765.997C767.332 1219.92 768.464 1220.41 769.392 1221.4C770.379 1222.33 770.872 1223.46 770.872 1224.79V1229.93C770.872 1235.5 768.493 1239.74 763.734 1242.64C763.27 1242.93 762.777 1243.07 762.254 1243.07ZM811.831 1229.93C810.728 1229.93 809.799 1229.55 809.045 1228.8C808.291 1228.04 807.913 1227.12 807.913 1226.01V1173.17C807.913 1172.07 808.291 1171.14 809.045 1170.39C809.799 1169.58 810.728 1169.17 811.831 1169.17H846.736C847.781 1169.17 848.651 1169.55 849.348 1170.3C850.102 1171 850.479 1171.87 850.479 1172.91C850.479 1173.96 850.102 1174.83 849.348 1175.53C848.651 1176.22 847.781 1176.57 846.736 1176.57H815.835V1195.81H843.603C844.647 1195.81 845.518 1196.18 846.214 1196.94C846.969 1197.64 847.346 1198.51 847.346 1199.55C847.346 1200.59 846.969 1201.47 846.214 1202.16C845.518 1202.86 844.647 1203.21 843.603 1203.21H815.835V1222.53H846.736C847.781 1222.53 848.651 1222.91 849.348 1223.66C850.102 1224.36 850.479 1225.23 850.479 1226.27C850.479 1227.32 850.102 1228.19 849.348 1228.89C848.651 1229.58 847.781 1229.93 846.736 1229.93H811.831ZM876.252 1230.36C875.207 1230.36 874.249 1230.07 873.379 1229.49C872.508 1228.86 871.87 1228.07 871.464 1227.14L856.318 1190.93C856.028 1190.24 855.882 1189.63 855.882 1189.1C855.882 1188 856.26 1187.07 857.014 1186.32C857.769 1185.51 858.697 1185.1 859.8 1185.1C860.554 1185.1 861.25 1185.33 861.889 1185.8C862.585 1186.2 863.078 1186.73 863.369 1187.36L876.687 1221.14L890.005 1187.36C890.295 1186.73 890.759 1186.2 891.398 1185.8C892.094 1185.33 892.819 1185.1 893.574 1185.1C894.676 1185.1 895.605 1185.51 896.359 1186.32C897.114 1187.07 897.491 1188 897.491 1189.1C897.491 1189.63 897.346 1190.24 897.056 1190.93L881.91 1227.14C881.503 1228.07 880.865 1228.86 879.995 1229.49C879.124 1230.07 878.167 1230.36 877.122 1230.36H876.252ZM925.906 1230.8C918.827 1230.8 913.285 1228.8 909.28 1224.79C905.334 1220.73 903.361 1215.04 903.361 1207.73C903.361 1203.61 904.116 1199.81 905.624 1196.33C907.133 1192.85 909.455 1190.03 912.588 1187.89C915.722 1185.74 919.581 1184.67 924.166 1184.67C928.46 1184.67 932.174 1185.68 935.308 1187.71C938.441 1189.68 940.821 1192.35 942.445 1195.72C944.07 1199.03 944.883 1202.65 944.883 1206.6C944.883 1207.7 944.506 1208.63 943.751 1209.39C943.055 1210.14 942.097 1210.52 940.879 1210.52H911.37C911.834 1214.58 913.343 1217.74 915.896 1220.01C918.449 1222.27 922.018 1223.4 926.603 1223.4C929.04 1223.4 931.158 1223.17 932.957 1222.7C934.814 1222.24 936.613 1221.57 938.354 1220.7C938.818 1220.47 939.341 1220.35 939.921 1220.35C940.85 1220.35 941.662 1220.67 942.358 1221.31C943.055 1221.95 943.403 1222.76 943.403 1223.75C943.403 1225.03 942.649 1226.1 941.14 1226.97C938.876 1228.25 936.642 1229.2 934.437 1229.84C932.232 1230.48 929.388 1230.8 925.906 1230.8ZM937.048 1204.08C936.874 1201.23 936.12 1198.85 934.785 1196.94C933.509 1195.02 931.913 1193.63 929.998 1192.76C928.083 1191.83 926.139 1191.37 924.166 1191.37C922.192 1191.37 920.248 1191.83 918.333 1192.76C916.418 1193.63 914.822 1195.02 913.546 1196.94C912.269 1198.85 911.544 1201.23 911.37 1204.08H937.048ZM959.281 1230.36C958.178 1230.36 957.25 1229.99 956.495 1229.23C955.741 1228.48 955.364 1227.55 955.364 1226.45V1189.1C955.364 1188 955.741 1187.07 956.495 1186.32C957.25 1185.51 958.178 1185.1 959.281 1185.1C960.383 1185.1 961.312 1185.51 962.066 1186.32C962.879 1187.07 963.285 1188 963.285 1189.1V1192.85C967.347 1187.39 971.903 1184.67 976.951 1184.67H977.387C978.489 1184.67 979.389 1185.04 980.085 1185.8C980.84 1186.55 981.217 1187.48 981.217 1188.58C981.217 1189.68 980.84 1190.58 980.085 1191.28C979.331 1191.98 978.373 1192.33 977.213 1192.33H976.777C973.992 1192.33 971.438 1193.02 969.117 1194.41C966.796 1195.75 964.852 1197.61 963.285 1199.99V1226.45C963.285 1227.55 962.879 1228.48 962.066 1229.23C961.312 1229.99 960.383 1230.36 959.281 1230.36ZM998.61 1250.39C997.565 1250.39 996.666 1250.01 995.911 1249.25C995.215 1248.5 994.867 1247.6 994.867 1246.56C994.867 1246.09 994.954 1245.63 995.128 1245.16L1000.79 1230.63L984.421 1190.76C984.189 1190.18 984.073 1189.63 984.073 1189.1C984.073 1188 984.45 1187.07 985.205 1186.32C985.959 1185.51 986.888 1185.1 987.99 1185.1C988.803 1185.1 989.528 1185.33 990.166 1185.8C990.863 1186.26 991.356 1186.84 991.646 1187.54L1005.05 1220.79L1018.72 1187.71C1019.47 1185.97 1020.69 1185.1 1022.37 1185.1C1023.48 1185.1 1024.4 1185.51 1025.16 1186.32C1025.91 1187.07 1026.29 1188 1026.29 1189.1C1026.29 1189.63 1026.2 1190.12 1026.03 1190.58L1002.27 1247.69C1001.45 1249.49 1000.23 1250.39 998.61 1250.39ZM1053.21 1230.8C1049.61 1230.8 1046.19 1229.9 1042.94 1228.1C1039.75 1226.24 1037.14 1223.58 1035.11 1220.09C1033.13 1216.55 1032.15 1212.43 1032.15 1207.73C1032.15 1203.03 1033.13 1198.94 1035.11 1195.46C1037.14 1191.92 1039.75 1189.25 1042.94 1187.45C1046.19 1185.59 1049.61 1184.67 1053.21 1184.67C1058.9 1184.67 1063.86 1186.87 1068.1 1191.28V1169.95C1068.1 1168.79 1068.47 1167.84 1069.23 1167.08C1070.04 1166.33 1071 1165.95 1072.1 1165.95C1073.2 1165.95 1074.13 1166.36 1074.89 1167.17C1075.64 1167.92 1076.02 1168.85 1076.02 1169.95V1226.45C1076.02 1227.55 1075.64 1228.48 1074.89 1229.23C1074.13 1229.99 1073.2 1230.36 1072.1 1230.36C1071 1230.36 1070.04 1229.99 1069.23 1229.23C1068.47 1228.48 1068.1 1227.55 1068.1 1226.45V1224.18C1063.86 1228.59 1058.9 1230.8 1053.21 1230.8ZM1054.34 1223.4C1057.01 1223.4 1059.51 1222.82 1061.83 1221.66C1064.21 1220.44 1066.3 1218.85 1068.1 1216.87V1198.59C1066.3 1196.62 1064.21 1195.05 1061.83 1193.89C1059.51 1192.67 1057.01 1192.06 1054.34 1192.06C1050.05 1192.06 1046.6 1193.43 1043.99 1196.16C1041.37 1198.88 1040.07 1202.74 1040.07 1207.73C1040.07 1212.72 1041.37 1216.58 1043.99 1219.31C1046.6 1222.04 1050.05 1223.4 1054.34 1223.4ZM1101.08 1230.8C1098.52 1230.8 1096.14 1230.28 1093.94 1229.23C1091.79 1228.19 1090.08 1226.68 1088.8 1224.71C1087.53 1222.68 1086.89 1220.35 1086.89 1217.74C1086.89 1213.45 1088.57 1210.02 1091.94 1207.47C1095.36 1204.92 1100.35 1203.64 1106.91 1203.64H1117.44V1202.95C1117.44 1199.12 1116.48 1196.36 1114.57 1194.68C1112.71 1192.99 1109.78 1192.15 1105.78 1192.15C1103.57 1192.15 1101.6 1192.33 1099.86 1192.67C1098.17 1193.02 1096.29 1193.54 1094.2 1194.24C1093.73 1194.36 1093.36 1194.41 1093.07 1194.41C1092.2 1194.41 1091.44 1194.1 1090.8 1193.46C1090.17 1192.82 1089.85 1192.04 1089.85 1191.11C1089.85 1189.54 1090.6 1188.44 1092.11 1187.8C1097.04 1185.71 1102.06 1184.67 1107.17 1184.67C1111.17 1184.67 1114.54 1185.48 1117.27 1187.1C1120.05 1188.73 1122.08 1190.85 1123.36 1193.46C1124.69 1196.01 1125.36 1198.8 1125.36 1201.81V1226.45C1125.36 1227.55 1124.96 1228.48 1124.14 1229.23C1123.39 1229.99 1122.46 1230.36 1121.36 1230.36C1120.26 1230.36 1119.33 1229.99 1118.57 1229.23C1117.82 1228.48 1117.44 1227.55 1117.44 1226.45V1224.18C1113.15 1228.59 1107.69 1230.8 1101.08 1230.8ZM1104.04 1223.84C1106.59 1223.84 1109.06 1223.23 1111.43 1222.01C1113.81 1220.73 1115.82 1219.16 1117.44 1217.31V1210H1107.95C1099.19 1210 1094.81 1212.29 1094.81 1216.87C1094.81 1218.96 1095.5 1220.64 1096.9 1221.92C1098.35 1223.2 1100.73 1223.84 1104.04 1223.84ZM1147.8 1250.39C1146.75 1250.39 1145.85 1250.01 1145.1 1249.25C1144.4 1248.5 1144.05 1247.6 1144.05 1246.56C1144.05 1246.09 1144.14 1245.63 1144.32 1245.16L1149.97 1230.63L1133.61 1190.76C1133.38 1190.18 1133.26 1189.63 1133.26 1189.1C1133.26 1188 1133.64 1187.07 1134.39 1186.32C1135.15 1185.51 1136.07 1185.1 1137.18 1185.1C1137.99 1185.1 1138.72 1185.33 1139.35 1185.8C1140.05 1186.26 1140.54 1186.84 1140.83 1187.54L1154.24 1220.79L1167.9 1187.71C1168.66 1185.97 1169.88 1185.1 1171.56 1185.1C1172.66 1185.1 1173.59 1185.51 1174.35 1186.32C1175.1 1187.07 1175.48 1188 1175.48 1189.1C1175.48 1189.63 1175.39 1190.12 1175.22 1190.58L1151.45 1247.69C1150.64 1249.49 1149.42 1250.39 1147.8 1250.39Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M594.291 711.628L593.123 727.313C592.728 732.603 588.221 736.484 582.932 736.09L565.241 734.772C563.519 741.888 561.081 748.767 558.018 755.416L572.77 765.41C577.048 768.297 578.163 774.249 575.277 778.526L566.422 791.529C563.535 795.807 557.583 796.923 553.214 794.029L538.561 783.95C533.488 789.257 528.001 793.983 522.001 798.213L529.79 814.29C532.01 818.95 530.025 824.671 525.366 826.892L511.103 833.713C506.438 836.025 500.807 834.048 498.503 829.291L490.806 813.22C483.868 815.271 476.704 816.662 469.32 817.304L467.994 835.085C467.607 840.284 463.099 844.165 457.902 843.778L442.217 842.609C437.02 842.222 433.046 837.708 433.433 832.509L434.758 814.728C427.642 813.006 420.763 810.567 414.205 807.511L404.12 822.257C401.226 826.627 395.366 827.747 391.004 824.763L378.001 815.909C373.723 813.022 372.608 807.07 375.494 802.791L385.58 788.046C380.272 782.974 375.546 777.487 371.317 771.487L355.24 779.275C350.581 781.496 344.952 779.517 342.64 774.852L335.811 760.68C333.59 756.021 335.575 750.301 340.234 748.081L356.304 740.384C354.26 733.354 352.869 726.189 352.22 718.897L334.438 717.571C329.241 717.184 325.358 712.677 325.752 707.387L326.921 691.703C327.308 686.505 331.816 682.623 337.014 683.01L354.796 684.335C356.525 677.129 358.964 670.25 362.02 663.692L347.268 653.698C342.99 650.811 341.874 644.859 344.761 640.582L353.622 627.488C356.6 623.216 362.46 622.095 366.739 624.981L381.481 635.067C386.455 629.843 392.039 625.033 398.034 620.895L390.246 604.817C388.032 600.067 390.01 594.438 394.676 592.127L408.847 585.296C413.597 583.084 419.227 585.062 421.447 589.721L429.228 605.89C436.174 603.748 443.338 602.356 450.631 601.708L451.949 584.014C452.343 578.725 456.943 574.85 462.14 575.238L477.825 576.406C483.022 576.794 486.905 581.301 486.511 586.59L485.192 604.282C492.399 606.01 499.278 608.449 505.83 611.596L515.83 596.753C518.808 592.482 524.669 591.359 528.947 594.245L542.041 603.107C546.312 606.085 547.434 611.944 544.541 616.314L534.456 631.06C539.769 636.041 544.489 641.618 548.725 647.529L564.711 639.733C569.461 637.52 575.182 639.504 577.402 644.163L584.224 658.426C586.445 663.084 584.46 668.805 579.801 671.025L563.731 678.722C565.781 685.661 567.173 692.825 567.815 700.208L585.506 701.527C590.797 701.923 594.679 706.432 594.291 711.628Z",
    fill: "url(#paint0_linear_4941_9161)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.859 779.993C416.604 779.825 411.249 780.667 411.014 780.649L413.073 774.424L418.504 772.879L425.2 773.378C425.952 774.379 428.589 778.309 433.117 786.017C434.353 790.362 428.458 789.096 426.59 788.012L424.307 785.361L422.116 781.476C420.53 781.358 421.115 780.162 418.859 779.993Z",
    fill: "url(#paint1_linear_4941_9161)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.64 659.825L421.922 660.443C418.89 663.879 412.726 672.09 412.327 677.447C411.828 684.143 408.969 684.461 405.966 686.718C403.563 688.523 402.426 691.416 402.158 692.636C400.984 690.954 398.074 686.094 395.827 680.115L396.365 672.89C396.512 670.917 398.825 670.002 399.963 669.792L400.383 664.153C402.922 662.57 408.565 659.447 410.821 659.615L413.64 659.825Z",
    fill: "url(#paint2_linear_4941_9161)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.97 655C341.923 650.648 342.931 644.096 344.316 641.364L347.983 635.642L350.139 639.318L349.955 641.784L349.876 642.842L351.462 642.96L352.695 643.052L354.105 643.157L356.414 645.455L356.323 646.689L356.786 647.609C357.248 648.53 358.159 650.582 358.096 651.428L358.004 652.661L356.665 653.979L356.195 655.539L356.129 656.42L356.258 659.442C356.765 659.775 356.017 659.353 348.97 655Z",
    fill: "url(#paint3_linear_4941_9161)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.948 684.153L344.375 683.365C343.885 684.391 343.435 686.945 345.554 688.945C347.673 690.946 346.384 690.484 345.475 690.003L340.97 693.388L340.839 695.15L343.482 695.347L347.49 693.874C349.705 694.275 354.745 694.485 357.19 692.116C357.358 689.861 358.552 691.273 359.128 692.26L359.299 689.97L359.561 686.445L363.088 681.924C362.026 677.947 359.661 670.364 358.7 671.852C357.738 673.339 355.798 680.672 354.948 684.153Z",
    fill: "url(#paint4_linear_4941_9161)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M557.953 755.349L561.99 745.546C561.166 744.761 558.879 743.539 556.319 744.931C553.758 746.322 554.599 745.241 555.339 744.527L553.522 739.193L551.888 738.52L550.879 740.971L551.033 745.238C549.963 747.218 548.195 751.943 549.687 755.003C551.778 755.864 550.065 756.56 548.947 756.8L551.071 757.675L554.338 759.021L557.539 763.778C561.649 764.006 569.591 764.117 568.477 762.741C567.362 761.364 560.996 757.24 557.953 755.349Z",
    fill: "url(#paint5_linear_4941_9161)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.673 700.695L386.962 696.818L387.907 700.787L387.381 707.835C388.259 710.322 389.194 717.751 385.911 727.571L384.874 724.836L385.202 720.431L381.909 714.692L378.561 714.443L378.85 710.566L379.099 707.218L382.736 703.591L386.673 700.695Z",
    fill: "url(#paint6_linear_4941_9161)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M541.08 713.972L541.369 710.096L542.313 714.064L541.788 721.113C542.666 723.6 543.601 731.029 540.317 740.848L539.281 738.113L539.609 733.708L536.316 727.97L532.968 727.72L533.257 723.844L533.506 720.495L537.143 716.868L541.08 713.972Z",
    fill: "url(#paint7_linear_4941_9161)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.237 630.833L507.298 627.463L510.309 630.216L513.834 636.342C515.957 637.907 520.904 643.528 523.704 653.496L521.31 651.816L519.107 647.987L513.159 645.089L510.249 646.764L508.31 643.394L506.636 640.484L507.607 635.44L509.237 630.833Z",
    fill: "url(#paint8_linear_4941_9161)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.423 740.431L354.371 732.305C355.296 731.783 357.19 730.14 357.369 727.744C357.548 725.347 359.323 726.885 360.188 727.954L362.479 728.125L364.899 731.317L366.706 733.224L367.808 735.078L369.923 735.235L372.382 737.899L372.146 741.071L369.463 741.403L367.388 740.717L366.115 741.153C365.19 741.675 362.471 742.973 358.993 743.989C357.108 744.558 358.129 745.283 358.875 745.575L361.166 745.746L360.995 748.037L358.573 749.628L354.539 751.454L352.887 752.217L349.539 751.967L347.601 751.823L344.605 751.599L343.019 751.481L343.374 746.723L356.423 740.431Z",
    fill: "url(#paint9_linear_4941_9161)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M534.34 630.959L540.168 636.983C539.626 637.896 538.801 640.264 539.84 642.431C540.879 644.598 538.574 644.149 537.291 643.653L535.22 644.647L531.531 643.084L529.014 642.331L527.135 641.272L525.223 642.189L521.764 641.105L520.388 638.237L522.549 636.613L524.69 636.174L525.576 635.161C526.118 634.248 527.83 631.768 530.339 629.154C531.69 627.722 530.443 627.602 529.651 627.72L527.58 628.713L526.587 626.642L527.894 624.056L530.483 620.463L531.534 618.979L534.562 617.527L536.314 616.687L539.023 615.388L540.457 614.7L542.52 619.002L534.34 630.959Z",
    fill: "url(#paint10_linear_4941_9161)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.694 645.977C432.918 646.979 433.752 649.096 434.392 650.03L489.546 654.14L489.848 650.087L490.163 645.858L487.674 636.459L483.061 634.166L483.98 621.831L484.322 617.25L480.968 614.696L481.152 612.229L484.939 608.968L485.28 604.386L486.58 586.941C487.19 578.765 481.677 576.653 478.844 576.619L478.647 579.262C478.116 580.05 476.816 581.961 475.865 583.308C474.914 584.654 474.037 585.652 473.717 585.982L473.507 588.802L473.27 591.974L471.193 596.071L472.574 601.313L470.497 605.411L468.382 605.253L460.093 607.116L455.706 608.915L454.368 610.233L451.012 612.464L450.841 614.755L450.605 617.926L449.09 619.231L443.841 623.092C444.502 623.732 445.803 625.294 445.719 626.422L445.352 631.356L443.093 633.136L440.978 632.979L440.794 635.446L440.531 638.97L440.295 642.142C439.168 643.003 436.469 644.975 434.694 645.977Z",
    fill: "url(#paint11_linear_4941_9161)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.956 612.441L408.18 609.446L410.47 609.617L415.993 606.839C418.381 608.08 423.642 611.201 425.578 613.755C427.998 616.947 426.13 618.226 417.912 621.511L414.746 623.579C412.931 624.152 408.368 623.564 404.632 616.624L407.628 616.847L407.956 612.441Z",
    fill: "url(#paint12_linear_4941_9161)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.977 653.982L390.397 648.343L394.627 648.659L398.151 648.921L394.206 654.297L388.318 657.225L389.977 653.982Z",
    fill: "url(#paint13_linear_4941_9161)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.193 783.739C379.736 782.354 374.106 775.001 371.473 771.497L373.94 771.681C375.62 771.334 379.396 770.28 381.062 768.845C383.145 767.051 382.401 767.527 382.493 766.294C382.566 765.307 383.698 765.97 384.255 766.425L386.898 766.622L386.806 767.856L386.701 769.265L387.966 771.309L389.623 772.85L391.47 774.228L392.703 774.319L398.4 776.339C395.581 776.129 397.939 778.714 398.137 779.863C398.335 781.012 396.218 781.846 395.134 782.12L393.901 782.028L388.967 781.66C386.982 782.93 382.649 785.123 381.193 783.739Z",
    fill: "url(#paint14_linear_4941_9161)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.97 680.098C565.539 682.025 566.738 691.209 567.266 695.56L565.222 694.167C563.593 693.628 559.796 692.652 557.636 693.062C554.935 693.574 555.818 693.534 555.121 694.556C554.564 695.374 553.916 694.234 553.661 693.561L551.471 692.069L552.167 691.047L552.963 689.879L552.889 687.476L552.224 685.313L551.314 683.197L550.292 682.501L546.368 677.903C548.704 679.495 547.954 676.076 548.357 674.983C548.76 673.889 551.012 674.225 552.087 674.53L553.109 675.226L557.198 678.011C559.552 677.904 564.401 678.172 564.97 680.098Z",
    fill: "url(#paint15_linear_4941_9161)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.218 843.878L450.641 843.313L453.868 838.061L455.396 836.58L455.527 834.818L453.283 831.638L451.613 830.273L454.748 826.255L456.039 827.945C457.146 828.146 459.719 828.503 461.149 828.326C462.58 828.149 463.939 827.353 464.439 826.977L464.689 823.629C464.794 822.219 464.846 821.514 462.003 816.873C460.711 815.182 461.821 814.555 462.279 813.172C462.645 812.065 464.773 809.814 465.792 808.827C466.52 809.354 468.284 810.572 469.511 811.23C470.738 811.889 470.722 813.211 470.561 813.789L469.051 817.398L467.843 833.609C467.202 842.208 461.16 844.038 458.218 843.878Z",
    fill: "url(#paint16_linear_4941_9161)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.629 713.484C511.421 743.113 485.633 765.325 456.004 763.117C426.417 760.912 404.206 735.124 406.414 705.494C408.619 675.907 434.407 653.695 463.994 655.9C493.623 658.108 515.834 683.897 513.629 713.484Z",
    fill: "#262626"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M454.703 780.569C493.971 783.495 528.155 754.052 531.081 714.784C534.005 675.551 504.553 641.374 465.294 638.448C426.069 635.525 391.885 664.968 388.962 704.193C386.036 743.452 415.469 777.645 454.703 780.569Z",
    stroke: "url(#paint17_linear_4941_9161)",
    strokeWidth: 35
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.854 791.987L492.025 789.696C492.282 789.42 493.952 787.607 498.581 782.565C499.757 780.101 500.48 781.644 500.695 782.723C501.213 783.706 502.515 787.784 503.587 796.228C504.08 803.883 501.354 797.656 499.487 798.934C497.993 799.957 496.633 799.194 496.139 798.685C494.956 798.715 492.347 798.686 491.381 798.33C490.174 797.886 489.209 796.574 489.49 795.177C489.771 793.78 491.762 793.22 491.854 791.987Z",
    fill: "url(#paint18_linear_4941_9161)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1082.63 760.743L1075.81 774.915C1073.51 779.694 1067.9 781.66 1063.12 779.36L1047.13 771.667C1042.93 777.661 1038.15 783.173 1032.87 788.242L1042.94 802.937C1045.87 807.188 1044.73 813.135 1040.48 816.062L1027.49 824.928C1023.24 827.855 1017.29 826.718 1014.28 822.428L1004.32 807.691C997.663 810.777 990.829 813.17 983.698 814.914L985.071 832.725C985.435 837.874 981.496 842.473 976.348 842.838L960.578 843.975C955.391 844.421 950.873 840.523 950.467 835.253L949.176 817.48C941.968 816.854 934.791 815.53 927.684 813.428L919.951 829.495C917.69 834.192 912.076 836.158 907.379 833.897L893.207 827.077C888.511 824.816 886.462 819.162 888.722 814.465L896.455 798.398C890.461 794.194 884.949 789.41 879.962 784.169L865.185 794.208C860.894 797.217 855.029 796.119 852.06 791.747L843.193 778.753C840.266 774.502 841.404 768.554 845.655 765.626L860.432 755.588C857.345 748.926 854.952 742.091 853.208 734.961L835.397 736.334C830.249 736.698 825.732 732.799 825.286 727.611L824.109 711.924C823.744 706.776 827.683 702.177 832.831 701.813L850.603 700.522C851.27 693.231 852.593 686.054 854.655 679.029L838.588 671.296C833.891 669.036 831.925 663.422 834.225 658.642L841.046 644.47C843.306 639.774 848.921 637.807 853.618 640.068L869.685 647.801C873.928 641.725 878.713 636.213 883.954 631.226L873.876 616.532C870.949 612.281 872.086 606.333 876.336 603.407L889.371 594.458C893.704 591.57 899.569 592.668 902.496 596.918L912.532 611.695C919.071 608.65 926.027 606.215 933.119 604.553L931.746 586.741C931.422 581.511 935.321 576.995 940.508 576.548L956.196 575.37C961.426 575.047 965.943 578.947 966.306 584.094L967.64 601.988C974.887 602.534 982.065 603.856 989.09 605.919L996.784 589.931C999.084 585.152 1004.78 583.226 1009.48 585.487L1023.65 592.307C1028.35 594.568 1030.31 600.182 1028.01 604.961L1020.32 620.947C1026.4 625.19 1031.91 629.974 1036.86 635.299L1051.59 625.138C1055.92 622.25 1061.79 623.348 1064.71 627.597L1073.66 640.632C1076.55 644.965 1075.45 650.829 1071.16 653.839L1056.39 663.878C1059.51 670.457 1061.87 677.374 1063.65 684.423L1081.38 683.01C1086.61 682.686 1091.21 686.624 1091.57 691.772L1092.71 707.542C1093.07 712.69 1089.13 717.289 1083.99 717.653L1066.21 718.944C1065.59 726.151 1064.26 733.329 1062.16 740.436L1078.15 748.129C1082.93 750.432 1084.89 756.047 1082.63 760.743Z",
    fill: "url(#paint19_linear_4941_9161)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M894.352 760.256C892.314 759.275 887.022 758.101 886.81 757.999L891.002 752.957L896.621 753.504L902.672 756.416C903.006 757.623 904.024 762.244 905.422 771.075C904.984 775.57 899.96 772.237 898.617 770.545L897.461 767.243L896.841 762.827C895.408 762.137 896.39 761.237 894.352 760.256Z",
    fill: "url(#paint20_linear_4941_9161)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M933.417 646.491L940.901 650.093C936.822 652.183 928.084 657.573 925.754 662.413C922.842 668.464 920.065 667.715 916.445 668.718C913.548 669.521 911.433 671.797 910.737 672.835C910.259 670.84 909.327 665.253 909.42 658.866L912.562 652.338C913.42 650.555 915.907 650.549 917.043 650.769L919.495 645.674C922.438 645.129 928.832 644.284 930.87 645.265L933.417 646.491Z",
    fill: "url(#paint21_linear_4941_9161)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.984 618.37C870.015 611.743 873.348 606.013 875.636 603.976L881.141 599.991L881.804 604.2L880.731 606.429L880.271 607.384L881.704 608.074L882.819 608.61L884.092 609.223L885.402 612.206L884.865 613.321L884.96 614.347C885.055 615.373 885.152 617.616 884.784 618.38L884.247 619.495L882.52 620.232L881.512 621.512L881.128 622.308L880.144 625.168C880.494 625.663 879.952 624.997 874.984 618.37Z",
    fill: "url(#paint22_linear_4941_9161)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M869.893 647.688L860.34 643.09C859.509 643.867 858.156 646.079 859.397 648.716C860.639 651.353 859.608 650.451 858.938 649.671L853.507 651.176L852.741 652.768L855.129 653.917L859.398 654.011C861.313 655.194 865.928 657.232 869.069 655.92C870.05 653.882 870.645 655.633 870.82 656.763L871.817 654.693L873.349 651.509L878.284 648.589C878.749 644.499 879.32 636.576 877.882 637.61C876.443 638.643 871.957 644.759 869.893 647.688Z",
    fill: "url(#paint23_linear_4941_9161)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1032.83 788.158L1040.17 780.509C1039.69 779.477 1038.01 777.504 1035.12 777.863C1032.22 778.222 1033.4 777.523 1034.35 777.129L1034.61 771.5L1033.33 770.276L1031.5 772.189L1030.08 776.217C1028.36 777.669 1024.99 781.421 1025.26 784.814C1026.89 786.38 1025.04 786.402 1023.92 786.217L1025.57 787.807L1028.12 790.254L1029.36 795.853C1033.1 797.567 1040.46 800.573 1039.92 798.885C1039.39 797.196 1034.97 791.03 1032.83 788.158Z",
    fill: "url(#paint24_linear_4941_9161)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M893.378 674.677L895.064 671.175L894.492 675.214L891.427 681.583C891.335 684.218 889.49 691.475 882.845 699.415L882.879 696.491L884.795 692.51L883.827 685.965L880.802 684.509L882.488 681.006L883.944 677.981L888.655 675.934L893.378 674.677Z",
    fill: "url(#paint25_linear_4941_9161)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1032.25 743.474L1033.93 739.971L1033.36 744.011L1030.3 750.38C1030.21 753.015 1028.36 760.272 1021.71 768.212L1021.75 765.287L1023.67 761.307L1022.7 754.762L1019.67 753.306L1021.36 749.803L1022.81 746.778L1027.52 744.731L1032.25 743.474Z",
    fill: "url(#paint26_linear_4941_9161)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1033 654.452L1032.42 650.607L1034.22 654.269L1035.26 661.26C1036.67 663.492 1039.22 670.532 1038.18 680.834L1036.56 678.395L1035.91 674.026L1031.44 669.155L1028.11 669.65L1027.54 665.805L1027.05 662.484L1029.79 658.144L1033 654.452Z",
    fill: "url(#paint27_linear_4941_9161)"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M850.697 700.612L851.757 692.298C852.808 692.15 855.172 691.313 856.214 689.148C857.256 686.983 858.347 689.063 858.762 690.374L860.831 691.37L861.917 695.227L862.902 697.662L863.25 699.79L865.161 700.71L866.476 704.088L865.097 706.954L862.479 706.283L860.798 704.885L859.454 704.827C858.402 704.974 855.397 705.188 851.788 704.863C849.826 704.703 850.511 705.752 851.099 706.296L853.168 707.292L852.172 709.362L849.336 709.958L844.914 710.183L843.098 710.289L840.072 708.833L838.321 707.991L835.614 706.688L834.181 705.998L836.25 701.699L850.697 700.612Z",
    fill: "url(#paint28_linear_4941_9161)"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1056.32 663.742L1059.54 671.479C1058.7 672.131 1057.07 674.034 1057.24 676.431C1057.42 678.827 1055.44 677.567 1054.42 676.637L1052.13 676.804L1049.27 674.001L1047.2 672.381L1045.84 670.708L1043.73 670.863L1040.9 668.589L1040.67 665.417L1043.27 664.695L1045.43 665.069L1046.62 664.45C1047.46 663.798 1049.96 662.116 1053.25 660.6C1055.03 659.761 1053.92 659.193 1053.14 659.014L1050.84 659.181L1050.68 656.89L1052.84 654.96L1056.56 652.562L1058.08 651.565L1061.43 651.321L1063.37 651.179L1066.37 650.96L1067.95 650.844L1068.3 655.602L1056.32 663.742Z",
    fill: "url(#paint29_linear_4941_9161)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M958.076 641.299C956.057 641.582 956.059 643.858 956.313 644.961L1006.15 668.946L1007.91 665.284L1009.75 661.463L1010.87 651.804L1007.41 647.984L1012.78 636.838L1014.77 632.698L1012.58 629.096L1013.65 626.867L1018.37 625.215L1020.36 621.075L1027.95 605.313C1031.51 597.925 1027.15 593.944 1024.52 592.877L1023.37 595.266C1022.59 595.804 1020.68 597.108 1019.3 598.014C1017.93 598.92 1016.75 599.528 1016.33 599.719L1015.1 602.266L1013.72 605.132L1010.29 608.187L1009.66 613.571L1006.23 616.626L1004.32 615.706L995.922 614.41L991.181 614.482L989.453 615.219L985.514 616.069L984.518 618.139L983.139 621.005L981.252 621.665L974.955 623.341C975.336 624.178 975.976 626.108 975.486 627.127L973.34 631.585L970.587 632.417L968.676 631.497L967.603 633.726L966.071 636.91L964.691 639.776C963.327 640.166 960.095 641.015 958.076 641.299Z",
    fill: "url(#paint30_linear_4941_9161)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M945.445 600.313L946.748 597.606L948.818 598.602L954.974 598.035C956.743 600.063 960.499 604.891 961.367 607.976C962.453 611.832 960.247 612.34 951.397 612.394L947.694 613.161C945.795 613.032 941.763 610.816 940.823 602.991L943.529 604.293L945.445 600.313Z",
    fill: "url(#paint31_linear_4941_9161)"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M913.525 632.407L915.977 627.312L919.799 629.151L922.983 630.684L917.346 634.246L910.795 634.819L913.525 632.407Z",
    fill: "url(#paint32_linear_4941_9161)"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.922 749.974C857.073 748.153 854.52 739.251 853.35 735.027L855.579 736.1C857.269 736.39 861.169 736.79 863.245 736.063C865.839 735.155 864.972 735.326 865.509 734.211C865.938 733.32 866.749 734.351 867.101 734.978L869.489 736.127L868.953 737.242L868.34 738.515L868.771 740.88L869.75 742.92L870.965 744.877L872.079 745.414L876.644 749.375C874.096 748.149 875.347 751.418 875.111 752.56C874.876 753.701 872.599 753.704 871.491 753.563L870.376 753.026L865.918 750.881C863.607 751.337 858.772 751.795 857.922 749.974Z",
    fill: "url(#paint33_linear_4941_9161)"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1066.87 720.677C1066.69 722.679 1064.45 731.665 1063.35 735.908L1061.96 733.865C1060.64 732.768 1057.46 730.472 1055.3 730.063C1052.6 729.553 1053.44 729.838 1052.41 730.535C1051.6 731.093 1051.41 729.794 1051.42 729.076L1049.93 726.886L1050.95 726.189L1052.12 725.392L1052.92 723.129L1053.1 720.873L1053.02 718.57L1052.33 717.548L1050.35 711.835C1051.95 714.171 1052.5 710.714 1053.27 709.844C1054.05 708.973 1056.02 710.108 1056.91 710.785L1057.61 711.807L1060.4 715.894C1062.62 716.655 1067.04 718.676 1066.87 720.677Z",
    fill: "url(#paint34_linear_4941_9161)"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M907.638 834.107L900.792 830.812L905.715 827.102L907.678 826.282L908.444 824.69L907.518 820.91L906.462 819.03L910.849 816.434L911.433 818.48C912.39 819.072 914.654 820.344 916.05 820.703C917.447 821.061 919.003 820.816 919.606 820.649L921.062 817.624C921.675 816.35 921.982 815.713 921.031 810.353C920.447 808.307 921.709 808.13 922.641 807.01C923.386 806.113 926.19 804.796 927.499 804.249C927.985 805.006 929.181 806.785 930.082 807.846C930.983 808.907 930.486 810.132 930.124 810.611L927.4 813.419L920.35 828.067C916.611 835.837 910.317 835.331 907.638 834.107Z",
    fill: "url(#paint35_linear_4941_9161)"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1006.88 732.987C993.99 759.759 961.867 771.008 935.095 758.123C908.362 745.257 897.113 713.134 909.998 686.361C922.865 659.628 954.988 648.378 981.722 661.245C1008.49 674.13 1019.74 706.253 1006.88 732.987Z",
    fill: "#262626"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M927.506 773.892C962.987 790.968 1005.57 776.057 1022.64 740.576C1039.71 705.126 1024.78 662.549 989.311 645.476C953.868 628.418 911.288 643.33 894.23 678.772C877.157 714.246 892.055 756.83 927.506 773.892Z",
    stroke: "url(#paint36_linear_4941_9161)",
    strokeWidth: 35
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M957.911 798.102L958.907 796.033C959.248 795.869 961.465 794.792 967.616 791.792C969.611 789.928 969.721 791.628 969.527 792.711C969.649 793.816 969.371 798.088 967.282 806.338C964.942 813.645 964.682 806.852 962.477 807.359C960.713 807.765 959.725 806.558 959.452 805.903C958.339 805.499 955.922 804.518 955.153 803.834C954.191 802.979 953.772 801.405 954.545 800.208C955.317 799.011 957.375 799.217 957.911 798.102Z",
    fill: "url(#paint37_linear_4941_9161)"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M646.063 746.486L631.609 738.141C626.735 735.327 625.101 729.23 627.915 724.356L637.327 708.054C631.319 703.129 625.867 697.628 620.923 691.637L604.573 701.132C599.842 703.891 593.639 702.214 590.88 697.484L582.532 683.029C579.773 678.298 581.449 672.095 586.228 669.252L602.614 659.89C599.879 652.596 597.89 645.174 596.612 637.489L577.656 637.525C572.179 637.501 567.625 632.967 567.649 627.49L567.701 610.714C567.641 605.189 572.125 600.718 577.734 600.708L596.642 600.757C597.879 593.179 599.851 585.69 602.64 578.337L586.254 568.876C581.464 566.11 579.831 560.013 582.596 555.223L590.94 540.77C593.706 535.98 599.851 534.262 604.642 537.028L621.028 546.488C625.953 540.48 631.454 535.028 637.397 530.168L627.949 513.733C625.106 508.953 626.735 502.835 631.598 500.041L646.052 491.692C650.783 488.933 656.986 490.61 659.746 495.341L669.193 511.776C676.487 509.039 683.909 507.051 691.593 505.773L691.557 486.817C691.581 481.341 696.067 476.872 701.591 476.812L718.284 476.814C723.761 476.838 728.314 481.372 728.289 486.848L728.241 505.756C735.903 507.041 743.392 509.013 750.661 511.753L760.122 495.367C762.887 490.577 768.985 488.943 773.859 491.757L788.312 500.102C793.102 502.867 794.736 508.965 791.971 513.755L782.51 530.141C788.602 535.114 794.053 540.615 798.913 546.558L815.264 537.063C819.995 534.304 826.198 535.98 828.956 540.711L837.389 555.215C840.099 560.029 838.471 566.148 833.741 568.907L817.307 578.351C820.008 585.513 822.032 593.067 823.226 600.703L842.183 600.668C847.743 600.741 852.212 605.225 852.271 610.75L852.27 627.443C852.196 633.003 847.71 637.472 842.234 637.447L823.194 637.435C822.04 645.061 820.07 652.55 817.329 659.819L833.634 669.233C838.508 672.047 840.092 678.228 837.327 683.018L828.982 697.471C826.217 702.261 820.12 703.895 815.246 701.082L798.943 691.669C793.969 697.761 788.469 703.212 782.441 708.024L792.021 724.423C794.731 729.238 793.104 735.357 788.374 738.117L773.87 746.549C769.055 749.259 762.938 747.632 760.094 742.853L750.646 726.418C743.437 729.202 735.931 731.143 728.329 732.468L728.415 751.341C728.341 756.9 723.808 761.455 718.332 761.43L701.555 761.379C696.079 761.355 691.525 756.821 691.55 751.345L691.598 732.438C684.021 731.2 676.531 729.229 669.179 726.44L659.767 742.743C656.95 747.618 650.851 749.251 646.063 746.486Z",
    fill: "url(#paint38_linear_4941_9161)"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M661.556 547.297C662.756 545.219 664.419 539.713 664.544 539.496L669.546 544.333L668.52 550.235L664.957 556.406C663.653 556.663 658.683 557.373 649.228 558.15C644.505 557.329 648.432 552.278 650.329 550.991L653.915 550.031L658.638 549.726C659.481 548.265 660.355 549.376 661.556 547.297Z",
    fill: "url(#paint39_linear_4941_9161)"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M778.826 597.685L774.42 605.317C772.533 600.836 767.524 591.16 762.588 588.31C756.418 584.748 757.43 581.868 756.657 577.958C756.038 574.829 753.798 572.41 752.755 571.591C754.904 571.244 760.89 570.702 767.641 571.309L774.298 575.152C776.117 576.202 775.925 578.834 775.602 580.019L780.798 583.019C781.141 586.176 781.526 593.009 780.326 595.087L778.826 597.685Z",
    fill: "url(#paint40_linear_4941_9161)"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M813.233 538.09C820.64 533.36 826.438 537.342 828.411 539.925L832.191 546.067L827.685 546.434L825.411 545.121L824.437 544.559L823.593 546.02L822.937 547.157L822.187 548.456L818.926 549.604L817.789 548.948L816.696 548.966C815.603 548.985 813.222 548.909 812.442 548.459L811.306 547.803L810.663 545.916L809.389 544.747L808.577 544.279L805.629 543.01C805.077 543.341 805.825 542.82 813.233 538.09Z",
    fill: "url(#paint41_linear_4941_9161)"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M782.614 530.371L788.239 520.628C787.483 519.687 785.25 518.08 782.361 519.183C779.472 520.287 780.508 519.268 781.387 518.621L780.227 512.755L778.603 511.817L777.197 514.253L776.758 518.763C775.354 520.695 772.831 525.415 773.969 528.844C776.047 530.044 774.147 530.535 772.938 530.63L775.048 531.849L778.296 533.724L780.993 539.178C785.284 539.996 793.622 541.23 792.643 539.625C791.664 538.021 785.549 532.787 782.614 530.371Z",
    fill: "url(#paint42_linear_4941_9161)"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M621.017 691.606L628.527 699.982C629.657 699.557 631.878 697.934 631.728 694.845C631.578 691.757 632.224 693.058 632.566 694.094L638.502 694.816L639.898 693.565L638.02 691.471L633.87 689.651C632.471 687.716 628.769 683.849 625.157 683.865C623.37 685.467 623.494 683.508 623.78 682.329L621.965 683.956L619.173 686.46L613.15 687.326C611.039 691.15 607.273 698.691 609.102 698.259C610.931 697.828 617.807 693.644 621.017 691.606Z",
    fill: "url(#paint43_linear_4941_9161)"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M752.185 553.073L755.757 555.136L751.529 554.21L745.033 550.46C742.252 550.153 734.72 547.623 726.847 539.96L729.939 540.229L733.998 542.573L741.001 542.07L742.782 538.984L746.354 541.047L749.44 542.828L751.231 547.976L752.185 553.073Z",
    fill: "url(#paint44_linear_4941_9161)"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.344 694.542L671.916 696.605L667.687 695.679L661.192 691.929C658.41 691.622 650.879 689.092 643.005 681.429L646.097 681.698L650.157 684.042L657.16 683.538L658.941 680.453L662.513 682.516L665.598 684.297L667.39 689.445L668.344 694.542Z",
    fill: "url(#paint45_linear_4941_9161)"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M762.483 702.421L766.598 702.121L762.579 703.73L755.099 704.277C752.625 705.585 744.973 707.723 734.155 705.806L736.864 704.292L741.539 703.951L747.049 699.6L746.79 696.047L750.904 695.747L754.457 695.487L758.831 698.74L762.483 702.421Z",
    fill: "url(#paint46_linear_4941_9161)"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter47_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M728.139 505.848L736.852 507.632C736.925 508.756 737.622 511.323 739.83 512.598C742.039 513.874 739.751 514.862 738.33 515.197L737.112 517.308L732.945 518.149L730.29 518.998L728.01 519.197L726.885 521.146L723.205 522.269L720.282 520.582L721.201 517.865L722.814 516.197L722.983 514.779C722.91 513.655 722.923 510.458 723.554 506.665C723.879 504.602 722.715 505.243 722.092 505.822L720.874 507.932L718.763 506.714L718.358 503.665L718.471 498.968L718.503 497.038L720.285 493.952L721.316 492.166L722.91 489.406L723.753 487.944L728.138 490.476L728.139 505.848Z",
    fill: "url(#paint47_linear_4941_9161)"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M750.798 726.352L742.354 729.146C741.731 728.208 739.848 726.329 737.298 726.323C734.748 726.318 736.239 724.321 737.304 723.323L737.309 720.886L740.503 718.08L742.382 716.021L744.26 714.713L744.264 712.463L746.895 709.656L750.27 709.663L750.827 712.476L750.26 714.725L750.82 716.039C751.443 716.978 753.024 719.756 754.367 723.359C755.113 725.311 755.802 724.175 756.054 723.363L756.059 720.925L758.497 720.93L760.367 723.372L762.608 727.501L763.542 729.191L763.535 732.753L763.53 734.816L763.524 738.003L763.52 739.691L758.457 739.68L750.798 726.352Z",
    fill: "url(#paint48_linear_4941_9161)"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter49_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M782.359 624.186C782.219 622.027 779.811 621.849 778.624 622.03L749.28 672.855L753.015 675.011L756.912 677.261L767.043 679.214L771.361 675.861L782.727 682.423L786.949 684.861L790.935 682.832L793.208 684.144L794.581 689.267L798.803 691.705L814.879 700.986C822.413 705.336 826.972 701.04 828.31 698.348L825.874 696.941C825.366 696.071 824.138 693.948 823.289 692.418C822.44 690.889 821.891 689.59 821.722 689.132L819.124 687.632L816.202 685.944L813.242 682.071L807.595 680.976L804.636 677.102L805.761 675.153L807.8 666.371L808.101 661.349L807.459 659.462L806.873 655.227L804.762 654.008L801.839 652.321L801.29 650.272L800.018 643.475C799.101 643.812 797.009 644.336 795.97 643.736L791.423 641.111L790.762 638.131L791.887 636.183L789.614 634.87L786.366 632.995L783.443 631.308C783.14 629.833 782.498 626.345 782.359 624.186Z",
    fill: "url(#paint49_linear_4941_9161)"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter50_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M826.732 614.085L829.493 615.678L828.274 617.789L828.384 624.348C826.097 626.059 820.69 629.649 817.357 630.323C813.19 631.165 812.829 628.791 813.475 619.421L812.958 615.442C813.246 613.443 815.911 609.353 824.266 608.98L822.673 611.741L826.732 614.085Z",
    fill: "url(#paint50_linear_4941_9161)"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M795.31 577.756L800.506 580.756L798.256 584.653L796.381 587.901L793.06 581.653L792.974 574.676L795.31 577.756Z",
    fill: "url(#paint51_linear_4941_9161)"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter52_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M675.329 509.57C677.324 508.816 686.947 506.823 691.509 505.921L690.197 508.194C689.755 509.96 689.022 514.055 689.626 516.308C690.381 519.126 690.268 518.195 691.405 518.851C692.314 519.376 691.159 520.153 690.468 520.475L689.061 522.911L687.925 522.255L686.626 521.505L684.089 521.772L681.853 522.646L679.685 523.776L679.029 524.913L674.473 529.428C675.973 526.83 672.415 527.893 671.226 527.553C670.037 527.212 670.215 524.804 670.453 523.642L671.109 522.505L673.734 517.959C673.435 515.477 673.335 510.324 675.329 509.57Z",
    fill: "url(#paint52_linear_4941_9161)"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter53_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689.712 732.992C687.608 732.648 678.277 729.562 673.875 728.062L676.148 726.75C677.414 725.442 680.096 722.262 680.7 720.008C681.455 717.191 681.086 718.053 680.43 716.916C679.905 716.007 681.294 715.912 682.054 715.979L684.49 714.572L685.146 715.709L685.896 717.008L688.226 718.044L690.6 718.406L693.043 718.511L694.179 717.855L700.382 716.223C697.783 717.723 701.397 718.581 702.257 719.47C703.116 720.359 701.758 722.356 700.971 723.244L699.834 723.9L695.288 726.525C694.306 728.824 691.815 733.336 689.712 732.992Z",
    fill: "url(#paint53_linear_4941_9161)"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter54_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.354 555.482L586.385 548.5L589.919 554.004L590.631 556.147L592.254 557.085L596.327 556.405L598.402 555.437L600.799 560.286L598.587 560.741C597.885 561.707 596.359 564.001 595.868 565.45C595.378 566.899 595.513 568.565 595.642 569.216L598.728 570.998C600.027 571.748 600.676 572.123 606.423 571.544C608.635 571.088 608.722 572.438 609.833 573.512C610.722 574.372 611.893 577.444 612.368 578.873C611.528 579.326 609.551 580.451 608.357 581.32C607.162 582.189 605.906 581.565 605.427 581.144L602.673 578.039L587.734 569.414C579.81 564.839 580.846 558.22 582.354 555.482Z",
    fill: "url(#paint54_linear_4941_9161)"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter55_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M681.459 668.528C654.155 652.764 644.807 617.879 660.571 590.576C676.312 563.311 711.197 553.964 738.501 569.728C765.766 585.469 775.114 620.354 759.372 647.619C743.609 674.922 708.723 684.269 681.459 668.528Z",
    fill: "#262626"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M645.415 581.826C624.819 617.5 637.035 663.087 672.709 683.683C708.351 704.261 753.936 692.035 774.528 656.369C795.102 620.734 782.885 575.146 747.251 554.572C711.584 533.98 665.994 546.183 645.415 581.826Z",
    stroke: "url(#paint55_linear_4941_9161)",
    strokeWidth: 35
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_i_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.454 611.541L618.565 612.76C618.711 613.133 619.674 615.565 622.36 622.312C624.174 624.572 622.366 624.553 621.235 624.261C620.057 624.302 615.559 623.668 606.994 620.802C599.449 617.745 606.658 618.01 606.296 615.636C606.007 613.737 607.363 612.788 608.077 612.55C608.594 611.405 609.824 608.926 610.609 608.166C611.59 607.217 613.289 606.899 614.494 607.811C615.699 608.724 615.318 610.885 616.454 611.541Z",
    fill: "url(#paint56_linear_4941_9161)"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M553.559 525.236C551.407 525.236 549.268 524.664 547.353 523.57L509.434 501.923C508.775 501.55 508.016 501.339 507.258 501.339C506.499 501.339 505.74 501.538 505.081 501.923L467.162 523.57C465.247 524.664 463.096 525.236 460.957 525.236C457.226 525.236 453.582 523.483 451.194 520.563C448.831 517.655 447.911 513.865 448.682 510.149L457.561 467.426C457.872 465.91 457.362 464.319 456.218 463.275L423.883 433.923C420.19 430.568 418.859 425.535 420.389 420.788C421.931 416.041 425.973 412.76 430.935 412.213L474.351 407.454C475.893 407.28 477.236 406.298 477.883 404.894L495.829 365.115C497.881 360.567 502.258 357.746 507.245 357.746C512.232 357.746 516.61 360.567 518.662 365.115L536.608 404.894C537.242 406.31 538.598 407.292 540.14 407.454L583.556 412.213C588.518 412.76 592.56 416.041 594.102 420.788C595.644 425.535 594.314 430.568 590.62 433.923L558.297 463.275C557.153 464.319 556.631 465.91 556.954 467.426L565.834 510.149C566.605 513.865 565.685 517.655 563.322 520.563C560.934 523.496 557.29 525.236 553.559 525.236Z",
    fill: "url(#paint57_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.956 366.794L532.902 406.573C534.133 409.306 536.72 411.17 539.692 411.506L583.108 416.265C590.359 417.061 593.269 426.033 587.871 430.929L555.549 460.282C553.335 462.295 552.353 465.327 552.95 468.26L561.829 510.983C563.309 518.116 555.673 523.659 549.355 520.042L511.436 498.395C508.837 496.916 505.641 496.916 503.042 498.395L465.123 520.042C458.793 523.659 451.157 518.116 452.649 510.983L461.529 468.26C462.138 465.327 461.156 462.295 458.929 460.282L426.619 430.917C421.222 426.021 424.144 417.048 431.382 416.253L474.798 411.494C477.771 411.17 480.358 409.294 481.589 406.56L499.535 366.782C502.532 360.146 511.971 360.146 514.956 366.782V366.794Z",
    fill: "url(#paint58_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.972 439.913C527.641 435.427 480.457 423.435 449.876 414.227L431.383 416.252C424.132 417.047 421.222 426.02 426.619 430.916L458.942 460.268C461.156 462.281 462.138 465.313 461.541 468.246L452.661 510.97C451.182 518.103 458.818 523.645 465.135 520.029L503.054 498.381C505.654 496.903 508.85 496.903 511.449 498.381L549.368 520.029C555.698 523.645 563.334 518.103 561.842 510.97L552.962 468.246C552.353 465.313 553.335 462.281 555.561 460.268L577.972 439.913Z",
    fill: "url(#paint59_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.293 445.977C530.526 463.349 490.642 470.495 460.484 473.266L452.649 510.982C451.169 518.115 458.805 523.657 465.122 520.041L503.041 498.393C505.641 496.914 508.837 496.914 511.436 498.393L549.355 520.041C555.685 523.657 563.321 518.115 561.829 510.982L552.949 468.258C552.34 465.325 553.322 462.293 555.549 460.28L571.281 445.989L571.293 445.977Z",
    fill: "url(#paint60_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.551 387.56C506.735 392.667 503.203 396.072 500.641 395.178C498.079 394.27 497.482 389.399 499.298 384.292C501.114 379.184 504.646 375.779 507.208 376.674C509.77 377.581 510.367 382.452 508.551 387.56Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.039 401.478C501.039 403.342 499.522 404.858 497.657 404.858C495.791 404.858 494.274 403.342 494.274 401.478C494.274 399.614 495.791 398.098 497.657 398.098C499.522 398.098 501.039 399.614 501.039 401.478Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.346 428.531C557.936 428.084 553.733 425.536 553.957 422.827C554.181 420.13 558.745 418.304 564.155 418.751C569.565 419.198 573.768 421.746 573.544 424.455C573.32 427.152 568.756 428.978 563.346 428.543V428.531Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.95 424.825C546.147 425.297 544.293 424.228 543.808 422.414C543.336 420.612 544.405 418.76 546.221 418.276C548.024 417.803 549.877 418.872 550.363 420.686C550.835 422.488 549.766 424.34 547.95 424.825Z",
    fill: "#FFF8E1"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.544 567.911C397.462 567.911 396.385 567.623 395.422 567.073L376.341 556.18C376.01 555.993 375.628 555.886 375.246 555.886C374.864 555.886 374.483 555.986 374.151 556.18L355.071 567.073C354.107 567.623 353.024 567.911 351.948 567.911C350.071 567.911 348.237 567.029 347.036 565.56C345.847 564.097 345.384 562.189 345.772 560.32L350.24 538.822C350.396 538.059 350.14 537.259 349.564 536.733L333.293 521.964C331.435 520.275 330.765 517.743 331.535 515.354C332.311 512.966 334.345 511.315 336.842 511.04L358.688 508.645C359.464 508.557 360.14 508.063 360.465 507.357L369.495 487.341C370.528 485.052 372.73 483.633 375.24 483.633C377.749 483.633 379.952 485.052 380.985 487.341L390.015 507.357C390.334 508.07 391.016 508.564 391.792 508.645L413.638 511.04C416.135 511.315 418.169 512.966 418.945 515.354C419.721 517.743 419.051 520.275 417.193 521.964L400.928 536.733C400.353 537.259 400.09 538.059 400.253 538.822L404.721 560.32C405.109 562.189 404.646 564.097 403.457 565.56C402.255 567.036 400.422 567.911 398.544 567.911Z",
    fill: "url(#paint61_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.119 488.186L388.15 508.202C388.769 509.578 390.071 510.516 391.566 510.685L413.413 513.08C417.061 513.48 418.525 517.994 415.809 520.458L399.545 535.228C398.431 536.241 397.937 537.767 398.237 539.242L402.705 560.74C403.45 564.329 399.608 567.118 396.429 565.299L377.349 554.406C376.041 553.662 374.432 553.662 373.124 554.406L354.044 565.299C350.859 567.118 347.017 564.329 347.768 560.74L352.236 539.242C352.542 537.767 352.048 536.241 350.928 535.228L334.67 520.452C331.954 517.988 333.424 513.474 337.067 513.073L358.913 510.678C360.408 510.516 361.71 509.572 362.33 508.196L371.36 488.18C372.868 484.841 377.618 484.841 379.119 488.18V488.186Z",
    fill: "url(#paint62_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.828 524.98C385.503 522.722 361.76 516.688 346.372 512.055L337.067 513.074C333.418 513.474 331.954 517.989 334.67 520.452L350.934 535.222C352.048 536.235 352.542 537.761 352.242 539.237L347.774 560.734C347.029 564.324 350.872 567.112 354.051 565.293L373.131 554.4C374.439 553.656 376.047 553.656 377.355 554.4L396.435 565.293C399.62 567.112 403.463 564.324 402.712 560.734L398.244 539.237C397.937 537.761 398.431 536.235 399.552 535.222L410.828 524.98Z",
    fill: "url(#paint63_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.468 528.027C386.954 536.769 366.885 540.365 351.71 541.759L347.768 560.737C347.023 564.326 350.865 567.115 354.044 565.295L373.124 554.403C374.432 553.658 376.041 553.658 377.349 554.403L396.429 565.295C399.614 567.115 403.456 564.326 402.705 560.737L398.237 539.239C397.931 537.763 398.425 536.238 399.545 535.225L407.461 528.034L407.468 528.027Z",
    fill: "url(#paint64_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.897 498.635C374.983 501.205 373.206 502.919 371.917 502.468C370.628 502.012 370.327 499.561 371.241 496.991C372.154 494.421 373.932 492.708 375.221 493.158C376.51 493.614 376.81 496.065 375.897 498.635Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.117 505.638C372.117 506.576 371.353 507.339 370.415 507.339C369.476 507.339 368.712 506.576 368.712 505.638C368.712 504.7 369.476 503.938 370.415 503.938C371.353 503.938 372.117 504.7 372.117 505.638Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.469 519.252C400.747 519.027 398.631 517.745 398.744 516.382C398.857 515.025 401.153 514.106 403.875 514.331C406.598 514.556 408.713 515.838 408.6 517.201C408.488 518.558 406.191 519.477 403.469 519.258V519.252Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.722 517.387C394.814 517.624 393.882 517.086 393.638 516.174C393.4 515.267 393.938 514.335 394.852 514.091C395.759 513.854 396.692 514.391 396.936 515.304C397.173 516.211 396.635 517.143 395.722 517.387Z",
    fill: "#FFF8E1"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1062.1 567.911C1061.02 567.911 1059.94 567.623 1058.98 567.073L1039.9 556.18C1039.57 555.993 1039.18 555.886 1038.8 555.886C1038.42 555.886 1038.04 555.986 1037.71 556.18L1018.63 567.073C1017.66 567.623 1016.58 567.911 1015.5 567.911C1013.63 567.911 1011.79 567.029 1010.59 565.56C1009.4 564.097 1008.94 562.189 1009.33 560.32L1013.8 538.822C1013.95 538.059 1013.7 537.259 1013.12 536.733L996.85 521.964C994.991 520.275 994.322 517.743 995.092 515.354C995.867 512.966 997.901 511.315 1000.4 511.04L1022.24 508.645C1023.02 508.557 1023.7 508.063 1024.02 507.357L1033.05 487.341C1034.08 485.052 1036.29 483.633 1038.8 483.633C1041.31 483.633 1043.51 485.052 1044.54 487.341L1053.57 507.357C1053.89 508.07 1054.57 508.564 1055.35 508.645L1077.19 511.04C1079.69 511.315 1081.73 512.966 1082.5 515.354C1083.28 517.743 1082.61 520.275 1080.75 521.964L1064.49 536.733C1063.91 537.259 1063.65 538.059 1063.81 538.822L1068.28 560.32C1068.67 562.189 1068.2 564.097 1067.01 565.56C1065.81 567.036 1063.98 567.911 1062.1 567.911Z",
    fill: "url(#paint65_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.68 488.186L1051.71 508.202C1052.33 509.578 1053.63 510.516 1055.12 510.685L1076.97 513.08C1080.62 513.48 1082.08 517.994 1079.37 520.458L1063.1 535.228C1061.99 536.241 1061.49 537.767 1061.79 539.242L1066.26 560.74C1067.01 564.329 1063.16 567.118 1059.99 565.299L1040.91 554.406C1039.6 553.662 1037.99 553.662 1036.68 554.406L1017.6 565.299C1014.42 567.118 1010.57 564.329 1011.32 560.74L1015.79 539.242C1016.1 537.767 1015.6 536.241 1014.48 535.228L998.226 520.452C995.511 517.988 996.981 513.474 1000.62 513.073L1022.47 510.678C1023.97 510.516 1025.27 509.572 1025.89 508.196L1034.92 488.18C1036.42 484.841 1041.17 484.841 1042.68 488.18V488.186Z",
    fill: "url(#paint66_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.38 524.98C1049.06 522.722 1025.32 516.688 1009.93 512.055L1000.62 513.074C996.975 513.474 995.511 517.989 998.227 520.452L1014.49 535.222C1015.6 536.235 1016.1 537.761 1015.8 539.237L1011.33 560.734C1010.59 564.324 1014.43 567.112 1017.61 565.293L1036.69 554.4C1038 553.656 1039.6 553.656 1040.91 554.4L1059.99 565.293C1063.18 567.112 1067.02 564.324 1066.27 560.734L1061.8 539.237C1061.49 537.761 1061.99 536.235 1063.11 535.222L1074.38 524.98Z",
    fill: "url(#paint67_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.02 528.027C1050.51 536.769 1030.44 540.365 1015.27 541.759L1011.32 560.737C1010.58 564.326 1014.42 567.115 1017.6 565.295L1036.68 554.403C1037.99 553.658 1039.6 553.658 1040.91 554.403L1059.99 565.295C1063.17 567.115 1067.01 564.326 1066.26 560.737L1061.79 539.239C1061.49 537.763 1061.98 536.238 1063.1 535.225L1071.02 528.034L1071.02 528.027Z",
    fill: "url(#paint68_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.45 498.635C1038.54 501.205 1036.76 502.919 1035.47 502.468C1034.18 502.012 1033.88 499.561 1034.8 496.991C1035.71 494.421 1037.49 492.708 1038.78 493.158C1040.07 493.614 1040.37 496.065 1039.45 498.635Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.67 505.638C1035.67 506.576 1034.91 507.339 1033.97 507.339C1033.03 507.339 1032.27 506.576 1032.27 505.638C1032.27 504.7 1033.03 503.938 1033.97 503.938C1034.91 503.938 1035.67 504.7 1035.67 505.638Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.03 519.252C1064.3 519.027 1062.19 517.745 1062.3 516.382C1062.41 515.025 1064.71 514.106 1067.43 514.331C1070.15 514.556 1072.27 515.838 1072.16 517.201C1072.04 518.558 1069.75 519.477 1067.03 519.258V519.252Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.28 517.387C1058.37 517.624 1057.44 517.086 1057.19 516.174C1056.96 515.267 1057.49 514.335 1058.41 514.091C1059.32 513.854 1060.25 514.391 1060.49 515.304C1060.73 516.211 1060.19 517.143 1059.28 517.387Z",
    fill: "#FFF8E1"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M755.187 417.49C753.035 417.49 750.896 416.918 748.981 415.824L711.062 394.177C710.403 393.804 709.644 393.593 708.886 393.593C708.127 393.593 707.368 393.791 706.709 394.177L668.79 415.824C666.875 416.918 664.724 417.49 662.584 417.49C658.853 417.49 655.21 415.737 652.822 412.817C650.459 409.909 649.539 406.119 650.31 402.403L659.189 359.68C659.5 358.164 658.99 356.573 657.846 355.529L625.511 326.177C621.817 322.822 620.487 317.789 622.016 313.042C623.559 308.294 627.6 305.014 632.563 304.467L675.979 299.708C677.521 299.534 678.864 298.552 679.511 297.148L697.457 257.369C699.509 252.821 703.886 250 708.873 250C713.86 250 718.238 252.821 720.29 257.369L738.236 297.148C738.87 298.564 740.226 299.546 741.768 299.708L785.184 304.467C790.146 305.014 794.188 308.294 795.73 313.042C797.272 317.789 795.941 322.822 792.248 326.177L759.925 355.529C758.781 356.573 758.259 358.164 758.582 359.68L767.462 402.403C768.233 406.119 767.313 409.909 764.95 412.817C762.562 415.75 758.918 417.49 755.187 417.49Z",
    fill: "url(#paint69_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.584 259.048L734.53 298.826C735.761 301.56 738.348 303.424 741.32 303.76L784.736 308.519C791.987 309.315 794.897 318.287 789.499 323.183L757.177 352.535C754.963 354.549 753.981 357.581 754.578 360.513L763.457 403.237C764.937 410.37 757.301 415.913 750.983 412.296L713.064 390.649C710.465 389.17 707.269 389.17 704.67 390.649L666.751 412.296C660.421 415.913 652.784 410.37 654.277 403.237L663.157 360.513C663.766 357.581 662.783 354.549 660.557 352.535L628.247 323.171C622.85 318.275 625.772 309.302 633.01 308.507L676.426 303.747C679.399 303.424 681.985 301.548 683.217 298.814L701.163 259.036C704.16 252.4 713.599 252.4 716.584 259.036V259.048Z",
    fill: "url(#paint70_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.6 332.167C729.269 327.681 682.085 315.689 651.504 306.48L633.01 308.506C625.76 309.301 622.85 318.274 628.247 323.17L660.57 352.522C662.784 354.535 663.766 357.567 663.169 360.5L654.289 403.224C652.809 410.357 660.445 415.899 666.763 412.283L704.682 390.635C707.281 389.157 710.478 389.157 713.077 390.635L750.996 412.283C757.326 415.899 764.962 410.357 763.47 403.224L754.59 360.5C753.981 357.567 754.963 354.535 757.189 352.522L779.6 332.167Z",
    fill: "url(#paint71_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.921 338.23C732.154 355.603 692.27 362.749 662.112 365.52L654.277 403.235C652.797 410.369 660.433 415.911 666.75 412.295L704.669 390.647C707.269 389.168 710.465 389.168 713.064 390.647L750.983 412.295C757.313 415.911 764.949 410.369 763.457 403.235L754.577 360.512C753.968 357.579 754.95 354.547 757.176 352.534L772.909 338.243L772.921 338.23Z",
    fill: "url(#paint72_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.179 279.814C708.363 284.921 704.831 288.326 702.269 287.431C699.707 286.524 699.11 281.653 700.926 276.546C702.742 271.438 706.274 268.033 708.836 268.928C711.398 269.835 711.995 274.706 710.179 279.814Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.667 293.732C702.667 295.596 701.15 297.112 699.285 297.112C697.419 297.112 695.902 295.596 695.902 293.732C695.902 291.868 697.419 290.352 699.285 290.352C701.15 290.352 702.667 291.868 702.667 293.732Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.974 320.785C759.564 320.337 755.361 317.79 755.585 315.081C755.809 312.384 760.373 310.558 765.783 311.005C771.193 311.452 775.396 314 775.172 316.709C774.948 319.405 770.384 321.232 764.974 320.797V320.785Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.578 317.079C747.774 317.551 745.921 316.482 745.436 314.668C744.964 312.866 746.033 311.014 747.849 310.53C749.652 310.057 751.505 311.126 751.99 312.94C752.463 314.742 751.393 316.594 749.578 317.079Z",
    fill: "#FFF8E1"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_4941_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M953.615 525.236C951.463 525.236 949.324 524.664 947.409 523.57L909.49 501.923C908.831 501.55 908.072 501.339 907.313 501.339C906.555 501.339 905.796 501.538 905.137 501.923L867.218 523.57C865.303 524.664 863.151 525.236 861.012 525.236C857.281 525.236 853.637 523.483 851.25 520.563C848.887 517.655 847.966 513.865 848.737 510.149L857.617 467.426C857.928 465.91 857.418 464.319 856.274 463.275L823.939 433.923C820.245 430.568 818.915 425.535 820.444 420.788C821.986 416.041 826.028 412.76 830.99 412.213L874.406 407.454C875.948 407.28 877.292 406.298 877.938 404.894L895.884 365.115C897.936 360.567 902.314 357.746 907.301 357.746C912.288 357.746 916.666 360.567 918.718 365.115L936.664 404.894C937.298 406.31 938.653 407.292 940.196 407.454L983.612 412.213C988.574 412.76 992.616 416.041 994.158 420.788C995.7 425.535 994.369 430.568 990.676 433.923L958.353 463.275C957.209 464.319 956.686 465.91 957.01 467.426L965.89 510.149C966.661 513.865 965.74 517.655 963.377 520.563C960.99 523.496 957.346 525.236 953.615 525.236Z",
    fill: "url(#paint73_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.012 366.794L932.958 406.573C934.189 409.306 936.776 411.17 939.748 411.506L983.164 416.265C990.414 417.061 993.325 426.033 987.927 430.929L955.604 460.282C953.391 462.295 952.408 465.327 953.005 468.26L961.885 510.983C963.365 518.116 955.729 523.659 949.411 520.042L911.492 498.395C908.893 496.916 905.697 496.916 903.097 498.395L865.178 520.042C858.848 523.659 851.212 518.116 852.705 510.983L861.584 468.26C862.194 465.327 861.211 462.295 858.985 460.282L826.675 430.917C821.277 426.021 824.2 417.048 831.438 416.253L874.854 411.494C877.826 411.17 880.413 409.294 881.644 406.56L899.59 366.782C902.588 360.146 912.027 360.146 915.012 366.782V366.794Z",
    fill: "url(#paint74_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.028 439.913C927.697 435.427 880.513 423.435 849.931 414.227L831.438 416.252C824.188 417.047 821.278 426.02 826.675 430.916L858.998 460.268C861.211 462.281 862.194 465.313 861.597 468.246L852.717 510.97C851.237 518.103 858.873 523.645 865.191 520.029L903.11 498.381C905.709 496.903 908.905 496.903 911.505 498.381L949.424 520.029C955.754 523.645 963.39 518.103 961.897 510.97L953.018 468.246C952.408 465.313 953.391 462.281 955.617 460.268L978.028 439.913Z",
    fill: "url(#paint75_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.349 445.977C930.582 463.349 890.698 470.495 860.539 473.266L852.704 510.982C851.224 518.115 858.86 523.657 865.178 520.041L903.097 498.393C905.696 496.914 908.893 496.914 911.492 498.393L949.411 520.041C955.741 523.657 963.377 518.115 961.885 510.982L953.005 468.258C952.396 465.325 953.378 462.293 955.604 460.28L971.336 445.989L971.349 445.977Z",
    fill: "url(#paint76_linear_4941_9161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.607 387.56C906.791 392.667 903.259 396.072 900.697 395.178C898.135 394.27 897.538 389.399 899.354 384.292C901.17 379.184 904.701 375.779 907.263 376.674C909.825 377.581 910.422 382.452 908.607 387.56Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.095 401.478C901.095 403.342 899.578 404.858 897.712 404.858C895.847 404.858 894.33 403.342 894.33 401.478C894.33 399.614 895.847 398.098 897.712 398.098C899.578 398.098 901.095 399.614 901.095 401.478Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.402 428.531C957.992 428.084 953.789 425.536 954.012 422.827C954.236 420.13 958.801 418.304 964.21 418.751C969.62 419.198 973.824 421.746 973.6 424.455C973.376 427.152 968.812 428.978 963.402 428.543V428.531Z",
    fill: "#FFF8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.005 424.825C946.202 425.297 944.349 424.228 943.864 422.414C943.392 420.612 944.461 418.76 946.277 418.276C948.08 417.803 949.933 418.872 950.418 420.686C950.891 422.488 949.821 424.34 948.005 424.825Z",
    fill: "#FFF8E1"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M260.05 1093C256.567 1093 253.633 1091.81 251.25 1089.42C248.867 1087.04 247.675 1084.11 247.675 1080.62V913.7C247.675 910.217 248.867 907.283 251.25 904.9C253.633 902.333 256.567 901.05 260.05 901.05H324.95C344.567 901.05 359.692 905.542 370.325 914.525C381.142 923.508 386.55 935.608 386.55 950.825C386.55 961.458 383.983 970.35 378.85 977.5C373.9 984.467 367.483 989.692 359.6 993.175C370.6 996.658 379.583 1002.25 386.55 1009.95C393.7 1017.65 397.275 1027.37 397.275 1039.1C397.275 1055.97 391.592 1069.17 380.225 1078.7C368.858 1088.23 350.983 1093 326.6 1093H260.05ZM318.35 984.1C334.667 984.1 346.125 981.35 352.725 975.85C359.325 970.35 362.625 962.65 362.625 952.75C362.625 944.133 359.05 937.258 351.9 932.125C344.933 926.992 335.308 924.425 323.025 924.425H272.7V984.1H318.35ZM324.125 1069.62C341.908 1069.62 354.467 1066.87 361.8 1061.37C369.317 1055.87 373.075 1048.08 373.075 1038C373.075 1017.1 356.85 1006.65 324.4 1006.65H272.7V1069.62H324.125ZM494.756 1095.75C472.389 1095.75 454.881 1089.42 442.231 1076.77C429.764 1063.94 423.531 1045.97 423.531 1022.87C423.531 1009.86 425.914 997.85 430.681 986.85C435.448 975.85 442.781 966.958 452.681 960.175C462.581 953.392 474.773 950 489.256 950C502.823 950 514.556 953.208 524.456 959.625C534.356 965.858 541.873 974.292 547.006 984.925C552.139 995.375 554.706 1006.83 554.706 1019.3C554.706 1022.78 553.514 1025.72 551.131 1028.1C548.931 1030.48 545.906 1031.67 542.056 1031.67H448.831C450.298 1044.51 455.064 1054.5 463.131 1061.65C471.198 1068.8 482.473 1072.37 496.956 1072.37C504.656 1072.37 511.348 1071.64 517.031 1070.17C522.898 1068.71 528.581 1066.6 534.081 1063.85C535.548 1063.12 537.198 1062.75 539.031 1062.75C541.964 1062.75 544.531 1063.76 546.731 1065.77C548.931 1067.79 550.031 1070.36 550.031 1073.47C550.031 1077.51 547.648 1080.9 542.881 1083.65C535.731 1087.68 528.673 1090.71 521.706 1092.72C514.739 1094.74 505.756 1095.75 494.756 1095.75ZM529.956 1011.32C529.406 1002.34 527.023 994.825 522.806 988.775C518.773 982.725 513.731 978.325 507.681 975.575C501.631 972.642 495.489 971.175 489.256 971.175C483.023 971.175 476.881 972.642 470.831 975.575C464.781 978.325 459.739 982.725 455.706 988.775C451.673 994.825 449.381 1002.34 448.831 1011.32H529.956ZM636.218 1095.75C609.451 1095.75 596.068 1083.65 596.068 1059.45V974.2H576.543C575.076 974.2 573.793 973.742 572.693 972.825C571.776 971.725 571.318 970.442 571.318 968.975C571.318 967.142 572.143 965.583 573.793 964.3L611.193 927.725C612.843 926.075 614.401 925.25 615.868 925.25C617.334 925.25 618.526 925.8 619.443 926.9C620.543 928 621.093 929.283 621.093 930.75V952.75H652.168C655.284 952.75 657.851 953.758 659.868 955.775C661.884 957.792 662.893 960.358 662.893 963.475C662.893 966.408 661.884 968.975 659.868 971.175C657.851 973.192 655.284 974.2 652.168 974.2H621.093V1057.25C621.093 1064.4 622.743 1068.98 626.043 1071C629.526 1072.83 633.834 1073.75 638.968 1073.75C642.634 1073.75 646.301 1073.2 649.968 1072.1C650.701 1071.92 651.434 1071.73 652.168 1071.55C653.084 1071.37 654.184 1071.27 655.468 1071.27C658.034 1071.27 660.326 1072.28 662.343 1074.3C664.359 1076.13 665.368 1078.42 665.368 1081.17C665.368 1085.39 663.259 1088.6 659.043 1090.8C651.893 1094.1 644.284 1095.75 636.218 1095.75ZM733.28 1094.38C729.613 1094.38 726.313 1093.28 723.38 1091.07C720.447 1088.87 718.43 1086.12 717.33 1082.82L678.28 968.425C677.73 966.775 677.455 965.217 677.455 963.75C677.455 960.267 678.647 957.333 681.03 954.95C683.413 952.567 686.347 951.375 689.83 951.375C692.397 951.375 694.688 952.108 696.705 953.575C698.905 954.858 700.372 956.6 701.105 958.8L733.28 1064.67L765.18 961.275C766.097 958.342 767.747 955.958 770.13 954.125C772.697 952.292 775.538 951.375 778.655 951.375C781.772 951.375 784.522 952.292 786.905 954.125C789.472 955.958 791.213 958.342 792.13 961.275L824.03 1064.67L856.205 958.8C856.938 956.6 858.313 954.858 860.33 953.575C862.53 952.108 864.913 951.375 867.48 951.375C870.963 951.375 873.897 952.567 876.28 954.95C878.663 957.333 879.855 960.267 879.855 963.75C879.855 965.217 879.58 966.775 879.03 968.425L839.98 1082.82C838.88 1086.12 836.863 1088.87 833.93 1091.07C830.997 1093.28 827.697 1094.38 824.03 1094.38C820.363 1094.38 817.063 1093.28 814.13 1091.07C811.197 1088.87 809.088 1086.03 807.805 1082.55L778.655 991.525L749.505 1082.55C748.222 1086.03 746.113 1088.87 743.18 1091.07C740.247 1093.28 736.947 1094.38 733.28 1094.38ZM921.103 924.15C917.253 924.15 913.953 922.775 911.203 920.025C908.453 917.275 907.078 913.975 907.078 910.125V909.025C907.078 905.175 908.453 901.875 911.203 899.125C913.953 896.375 917.253 895 921.103 895H922.753C926.603 895 929.903 896.375 932.653 899.125C935.403 901.875 936.778 905.175 936.778 909.025V910.125C936.778 913.975 935.403 917.275 932.653 920.025C929.903 922.775 926.603 924.15 922.753 924.15H921.103ZM921.653 1094.38C918.169 1094.38 915.236 1093.18 912.853 1090.8C910.469 1088.42 909.278 1085.48 909.278 1082V964.025C909.278 960.542 910.469 957.608 912.853 955.225C915.236 952.658 918.169 951.375 921.653 951.375C925.319 951.375 928.344 952.567 930.728 954.95C933.111 957.333 934.303 960.358 934.303 964.025V1082C934.303 1085.48 933.019 1088.42 930.453 1090.8C928.069 1093.18 925.136 1094.38 921.653 1094.38ZM984.359 1093C979.409 1093 975.284 1091.72 971.984 1089.15C968.684 1086.58 967.034 1083.01 967.034 1078.42C967.034 1074.21 968.501 1070.45 971.434 1067.15L1050.63 976.125H981.059C977.759 976.125 975.009 975.025 972.809 972.825C970.609 970.625 969.509 967.875 969.509 964.575C969.509 961.275 970.609 958.525 972.809 956.325C975.009 953.942 977.759 952.75 981.059 952.75H1064.38C1069.15 952.75 1073 954.217 1075.93 957.15C1078.87 960.083 1080.33 963.842 1080.33 968.425C1080.33 972.642 1079.05 976.308 1076.48 979.425L999.484 1069.62H1070.16C1073.46 1069.62 1076.21 1070.82 1078.41 1073.2C1080.79 1075.4 1081.98 1078.15 1081.98 1081.45C1081.98 1084.75 1080.79 1087.5 1078.41 1089.7C1076.21 1091.9 1073.46 1093 1070.16 1093H984.359ZM1127.1 1094.38C1123.61 1094.38 1120.68 1093.18 1118.3 1090.8C1115.91 1088.42 1114.72 1085.48 1114.72 1082V964.025C1114.72 960.542 1115.91 957.608 1118.3 955.225C1120.68 952.658 1123.61 951.375 1127.1 951.375C1130.58 951.375 1133.51 952.658 1135.9 955.225C1138.46 957.608 1139.75 960.542 1139.75 964.025V975.85C1152.58 958.617 1166.97 950 1182.92 950H1184.3C1187.78 950 1190.62 951.192 1192.82 953.575C1195.21 955.958 1196.4 958.892 1196.4 962.375C1196.4 965.858 1195.21 968.7 1192.82 970.9C1190.44 973.1 1187.41 974.2 1183.75 974.2H1182.37C1173.57 974.2 1165.51 976.4 1158.17 980.8C1150.84 985.017 1144.7 990.883 1139.75 998.4V1082C1139.75 1085.48 1138.46 1088.42 1135.9 1090.8C1133.51 1093.18 1130.58 1094.38 1127.1 1094.38Z",
    fill: "#FEA338"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4941_9161",
    x: 325.725,
    y: 575.211,
    width: 268.593,
    height: 268.594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40139 0 0 0 0 0.330909 0 0 0 0 0.278976 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4941_9161",
    x: 411.014,
    y: 772.879,
    width: 22.272,
    height: 20.1797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4941_9161",
    x: 395.827,
    y: 659.609,
    width: 26.0957,
    height: 37.0273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_4941_9161",
    x: 343.322,
    y: 635.641,
    width: 14.7769,
    height: 27.8906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_4941_9161",
    x: 340.839,
    y: 671.66,
    width: 22.2485,
    height: 27.6875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_4941_9161",
    x: 548.947,
    y: 738.52,
    width: 19.6357,
    height: 29.3984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_4941_9161",
    x: 378.561,
    y: 696.816,
    width: 9.65186,
    height: 34.7539,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_4941_9161",
    x: 532.968,
    y: 710.094,
    width: 9.65186,
    height: 34.7539,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_4941_9161",
    x: 506.636,
    y: 627.465,
    width: 17.0679,
    height: 30.0312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_4941_9161",
    x: 343.02,
    y: 726.473,
    width: 29.3628,
    height: 29.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_4941_9161",
    x: 520.388,
    y: 614.699,
    width: 22.1318,
    height: 33.9492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_4941_9161",
    x: 433.626,
    y: 576.617,
    width: 56.5366,
    height: 81.5234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_4941_9161",
    x: 404.632,
    y: 606.84,
    width: 21.9277,
    height: 20.9062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_4941_9161",
    x: 388.318,
    y: 648.344,
    width: 9.83301,
    height: 12.8828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_4941_9161",
    x: 371.473,
    y: 765.781,
    width: 26.9268,
    height: 22.3984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_4941_9161",
    x: 546.368,
    y: 674.23,
    width: 20.8984,
    height: 25.3281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_4941_9161",
    x: 450.641,
    y: 808.828,
    width: 19.9966,
    height: 39.0586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_4941_9161",
    x: 371.261,
    y: 620.746,
    width: 177.521,
    height: 181.523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_4941_9161",
    x: 489.441,
    y: 781.246,
    width: 14.2046,
    height: 22.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_4941_9161",
    x: 824.085,
    y: 575.352,
    width: 268.647,
    height: 268.656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.40139 0 0 0 0 0.330909 0 0 0 0 0.278976 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_4941_9161",
    x: 886.81,
    y: 752.957,
    width: 18.6118,
    height: 24.3711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_4941_9161",
    x: 909.414,
    y: 644.812,
    width: 31.4868,
    height: 32.0234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_i_4941_9161",
    x: 872.403,
    y: 599.992,
    width: 12.999,
    height: 29.3047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_i_4941_9161",
    x: 852.741,
    y: 637.516,
    width: 26.0576,
    height: 23.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_i_4941_9161",
    x: 1023.92,
    y: 770.277,
    width: 16.2539,
    height: 33.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_i_4941_9161",
    x: 880.802,
    y: 671.176,
    width: 14.2617,
    height: 32.2383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_i_4941_9161",
    x: 1019.67,
    y: 739.973,
    width: 14.2617,
    height: 32.2383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_i_4941_9161",
    x: 1027.05,
    y: 650.605,
    width: 11.373,
    height: 34.2305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_i_4941_9161",
    x: 834.181,
    y: 688.207,
    width: 32.2954,
    height: 26.082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_i_4941_9161",
    x: 1040.67,
    y: 650.844,
    width: 27.6304,
    height: 30.9688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_i_4941_9161",
    x: 956.197,
    y: 592.879,
    width: 73.0923,
    height: 80.0664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_i_4941_9161",
    x: 940.823,
    y: 597.605,
    width: 20.7993,
    height: 19.5547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_i_4941_9161",
    x: 910.795,
    y: 627.312,
    width: 12.1875,
    height: 11.5078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_i_4941_9161",
    x: 853.35,
    y: 733.863,
    width: 23.2939,
    height: 23.7617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_i_4941_9161",
    x: 1049.93,
    y: 709.527,
    width: 16.9458,
    height: 30.3789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_i_4941_9161",
    x: 900.792,
    y: 804.25,
    width: 29.7998,
    height: 34.5625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_i_4941_9161",
    x: 869.654,
    y: 620.91,
    width: 177.555,
    height: 181.559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_i_4941_9161",
    x: 954.144,
    y: 790.961,
    width: 15.4507,
    height: 22.7852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_i_4941_9161",
    x: 567.649,
    y: 476.812,
    width: 284.622,
    height: 284.617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.481956 0 0 0 0 0.362502 0 0 0 0 0.277177 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_i_4941_9161",
    x: 646.99,
    y: 539.496,
    width: 22.5562,
    height: 22.6523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_i_4941_9161",
    x: 752.755,
    y: 571.035,
    width: 28.3862,
    height: 38.2812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_i_4941_9161",
    x: 805.486,
    y: 535.891,
    width: 26.7051,
    height: 17.7148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_i_4941_9161",
    x: 772.938,
    y: 511.816,
    width: 19.7842,
    height: 32.5898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_i_4941_9161",
    x: 608.615,
    y: 682.328,
    width: 31.2822,
    height: 21.6523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_i_4941_9161",
    x: 726.847,
    y: 538.984,
    width: 28.9106,
    height: 20.1523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_i_4941_9161",
    x: 643.005,
    y: 680.453,
    width: 28.9106,
    height: 20.1523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_i_4941_9161",
    x: 734.155,
    y: 695.488,
    width: 32.4429,
    height: 15.082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_i_4941_9161",
    x: 718.357,
    y: 487.945,
    width: 22.3911,
    height: 38.3242,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_i_4941_9161",
    x: 735.892,
    y: 709.656,
    width: 27.6504,
    height: 34.0352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_i_4941_9161",
    x: 749.28,
    y: 621.977,
    width: 79.0298,
    height: 84.8672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_i_4941_9161",
    x: 812.958,
    y: 608.98,
    width: 16.5347,
    height: 25.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_i_4941_9161",
    x: 792.975,
    y: 574.676,
    width: 7.53125,
    height: 17.2266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_i_4941_9161",
    x: 670.279,
    y: 505.922,
    width: 21.4609,
    height: 27.5039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_i_4941_9161",
    x: 673.875,
    y: 714.574,
    width: 28.6567,
    height: 22.4375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_i_4941_9161",
    x: 581.304,
    y: 548.5,
    width: 31.064,
    height: 37.2578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_i_4941_9161",
    x: 617.906,
    y: 527.062,
    width: 184.118,
    height: 188.117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_i_4941_9161",
    x: 603.537,
    y: 607.27,
    width: 19.5942,
    height: 21.1289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4941_9161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4941_9161",
    x1: 406.187,
    y1: 586.264,
    x2: 522.5,
    y2: 827.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#876B59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239589,
    stopColor: "#7B695D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651058,
    stopColor: "#846C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978274"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4941_9161",
    x1: 422.948,
    y1: 773.211,
    x2: 421.815,
    y2: 788.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4941_9161",
    x1: 409.675,
    y1: 659.53,
    x2: 407.18,
    y2: 693.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4941_9161",
    x1: 351.682,
    y1: 635.357,
    x2: 349.916,
    y2: 659.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4941_9161",
    x1: 353.253,
    y1: 671.233,
    x2: 351.412,
    y2: 695.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4941_9161",
    x1: 570.758,
    y1: 757.756,
    x2: 547.851,
    y2: 748.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4941_9161",
    x1: 384.755,
    y1: 696.654,
    x2: 382.47,
    y2: 727.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4941_9161",
    x1: 539.162,
    y1: 709.931,
    x2: 536.877,
    y2: 740.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4941_9161",
    x1: 505.38,
    y1: 628.567,
    x2: 520.713,
    y2: 655.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4941_9161",
    x1: 359.054,
    y1: 726.539,
    x2: 357.116,
    y2: 752.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4941_9161",
    x1: 538.98,
    y1: 644.315,
    x2: 527.711,
    y2: 620.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4941_9161",
    x1: 467.189,
    y1: 575.738,
    x2: 461.502,
    y2: 652.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4941_9161",
    x1: 416.302,
    y1: 606.862,
    x2: 415.034,
    y2: 623.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4941_9161",
    x1: 393.569,
    y1: 648.58,
    x2: 392.9,
    y2: 657.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4941_9161",
    x1: 385.542,
    y1: 765.973,
    x2: 384.175,
    y2: 784.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4941_9161",
    x1: 552.32,
    y1: 693.309,
    x2: 562.673,
    y2: 678.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4941_9161",
    x1: 462.111,
    y1: 808.553,
    x2: 459.471,
    y2: 843.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4941_9161",
    x1: 464.015,
    y1: 655.901,
    x2: 456.025,
    y2: 763.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B6058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B19682"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4941_9161",
    x1: 497.724,
    y1: 781.092,
    x2: 496.342,
    y2: 799.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4941_9161",
    x1: 953.366,
    y1: 575.299,
    x2: 973.362,
    y2: 842.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#876B59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239589,
    stopColor: "#7B695D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651058,
    stopColor: "#846C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#978274"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4941_9161",
    x1: 900.637,
    y1: 755.437,
    x2: 894.024,
    y2: 769.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4941_9161",
    x1: 929.835,
    y1: 644.767,
    x2: 915.275,
    y2: 675.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4941_9161",
    x1: 884.687,
    y1: 601.077,
    x2: 874.385,
    y2: 622.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4941_9161",
    x1: 873.038,
    y1: 635.043,
    x2: 862.294,
    y2: 657.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4941_9161",
    x1: 1043.87,
    y1: 795.079,
    x2: 1025.99,
    y2: 777.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4941_9161",
    x1: 893.069,
    y1: 670.215,
    x2: 879.736,
    y2: 697.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4941_9161",
    x1: 1031.94,
    y1: 739.012,
    x2: 1018.61,
    y2: 766.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4941_9161",
    x1: 1030.23,
    y1: 650.933,
    x2: 1034.77,
    y2: 681.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4941_9161",
    x1: 858.222,
    y1: 688.642,
    x2: 846.919,
    y2: 712.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4941_9161",
    x1: 1055.75,
    y1: 677.87,
    x2: 1053.85,
    y2: 651.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4941_9161",
    x1: 1014,
    y1: 587.797,
    x2: 980.809,
    y2: 656.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4941_9161",
    x1: 955.252,
    y1: 598.169,
    x2: 947.855,
    y2: 613.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4941_9161",
    x1: 918.843,
    y1: 628.692,
    x2: 914.935,
    y2: 636.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4941_9161",
    x1: 868.464,
    y1: 735.027,
    x2: 860.49,
    y2: 751.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4941_9161",
    x1: 1050.26,
    y1: 728.351,
    x2: 1065.45,
    y2: 717.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA917F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4941_9161",
    x1: 924.173,
    y1: 802.649,
    x2: 908.77,
    y2: 834.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4941_9161",
    x1: 981.741,
    y1: 661.254,
    x2: 935.115,
    y2: 758.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B6058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B19682"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4941_9161",
    x1: 967.357,
    y1: 790.107,
    x2: 959.294,
    y2: 806.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAB3A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4941_9161",
    x1: 852.571,
    y1: 624.454,
    x2: 568.139,
    y2: 624.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7926C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239589,
    stopColor: "#9F7B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651058,
    stopColor: "#94735A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8160"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4941_9161",
    x1: 666.155,
    y1: 554.331,
    x2: 652.142,
    y2: 546.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C89875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97755D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4941_9161",
    x1: 780.935,
    y1: 594.032,
    x2: 750.083,
    y2: 576.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4941_9161",
    x1: 830.759,
    y1: 549.733,
    x2: 808.927,
    y2: 537.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA9376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583C29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4941_9161",
    x1: 795.744,
    y1: 534.704,
    x2: 772.978,
    y2: 521.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C89875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97755D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4941_9161",
    x1: 612.815,
    y1: 702.737,
    x2: 632.387,
    y2: 685.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C89875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97755D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4941_9161",
    x1: 756.931,
    y1: 553.102,
    x2: 728.677,
    y2: 536.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA9376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583C29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4941_9161",
    x1: 673.09,
    y1: 694.571,
    x2: 644.836,
    y2: 678.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C89D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B5C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4941_9161",
    x1: 766.427,
    y1: 699.779,
    x2: 733.888,
    y2: 702.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA9376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583C29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4941_9161",
    x1: 740.206,
    y1: 514.764,
    x2: 716.253,
    y2: 500.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C89D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B5C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4941_9161",
    x1: 735.893,
    y1: 724.633,
    x2: 763.551,
    y2: 724.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA9376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583C29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4941_9161",
    x1: 834.522,
    y1: 687.613,
    x2: 764.2,
    y2: 647.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_4941_9161",
    x1: 828.22,
    y1: 624.633,
    x2: 812.546,
    y2: 615.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA9376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583C29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_4941_9161",
    x1: 798.818,
    y1: 583.679,
    x2: 790.537,
    y2: 578.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C89875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97755D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_4941_9161",
    x1: 690.306,
    y1: 521.914,
    x2: 673.408,
    y2: 512.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C89875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97755D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4941_9161",
    x1: 682.913,
    y1: 714.813,
    x2: 692.669,
    y2: 731.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4A887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_4941_9161",
    x1: 614.326,
    y1: 575.481,
    x2: 581.688,
    y2: 556.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA9376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583C29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_4941_9161",
    x1: 759.361,
    y1: 647.638,
    x2: 660.56,
    y2: 590.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B5C47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C09678"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_4941_9161",
    x1: 624.163,
    y1: 622.172,
    x2: 607.078,
    y2: 612.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C89D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B5C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_4941_9161",
    x1: 515.802,
    y1: 300.247,
    x2: 502.279,
    y2: 497.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF9203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FF9C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFAE1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFC633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFE650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F4981E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_4941_9161",
    x1: 530.676,
    y1: 536.806,
    x2: 504.97,
    y2: 413.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFCC2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFD53E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FFDE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FFE967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF176"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_4941_9161",
    x1: 473.182,
    y1: 304.199,
    x2: 736.942,
    y2: 1529.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFAE15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFA000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_4941_9161",
    x1: 487.023,
    y1: 372.397,
    x2: 522.204,
    y2: 524.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFAE15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFA000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_4941_9161",
    x1: 379.545,
    y1: 454.7,
    x2: 372.741,
    y2: 553.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF9203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FF9C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFAE1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFC633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFE650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F4981E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_4941_9161",
    x1: 387.029,
    y1: 573.734,
    x2: 374.095,
    y2: 511.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFCC2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFD53E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FFDE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FFE967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF176"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_4941_9161",
    x1: 358.099,
    y1: 456.69,
    x2: 490.819,
    y2: 1073.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFAE15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFA000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_4941_9161",
    x1: 365.064,
    y1: 491.003,
    x2: 382.767,
    y2: 567.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFAE15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFA000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_4941_9161",
    x1: 1043.1,
    y1: 454.7,
    x2: 1036.3,
    y2: 553.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF9203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FF9C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFAE1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFC633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFE650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F4981E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_4941_9161",
    x1: 1050.59,
    y1: 573.734,
    x2: 1037.65,
    y2: 511.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFCC2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFD53E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FFDE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FFE967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF176"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_4941_9161",
    x1: 1021.66,
    y1: 456.69,
    x2: 1154.38,
    y2: 1073.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFAE15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFA000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_4941_9161",
    x1: 1028.62,
    y1: 491.003,
    x2: 1046.32,
    y2: 567.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFAE15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFA000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_4941_9161",
    x1: 717.43,
    y1: 192.501,
    x2: 703.907,
    y2: 389.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF9203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FF9C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFAE1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFC633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFE650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F4981E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_4941_9161",
    x1: 732.304,
    y1: 429.06,
    x2: 706.598,
    y2: 305.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFCC2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFD53E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FFDE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FFE967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF176"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_4941_9161",
    x1: 674.81,
    y1: 196.453,
    x2: 938.57,
    y2: 1421.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFAE15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFA000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_4941_9161",
    x1: 688.651,
    y1: 264.651,
    x2: 723.832,
    y2: 416.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFAE15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFA000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_4941_9161",
    x1: 915.857,
    y1: 300.247,
    x2: 902.335,
    y2: 497.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF9203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FF9C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFAE1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFC633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFE650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FFEE58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F4981E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF6C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_4941_9161",
    x1: 930.731,
    y1: 536.806,
    x2: 905.026,
    y2: 413.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFCC2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFCF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFD53E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FFDE50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FFE967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF176"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_4941_9161",
    x1: 873.237,
    y1: 304.199,
    x2: 1137,
    y2: 1529.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFAE15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFA000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_4941_9161",
    x1: 887.079,
    y1: 372.397,
    x2: 922.26,
    y2: 524.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFAE15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFA000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4941_9161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.957,
    height: 167.49,
    fill: "white",
    transform: "translate(419.767 357.746)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4941_9161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.0358,
    height: 84.2782,
    fill: "white",
    transform: "translate(331.222 483.633)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4941_9161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.0358,
    height: 84.2782,
    fill: "white",
    transform: "translate(994.778 483.633)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_4941_9161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.957,
    height: 167.49,
    fill: "white",
    transform: "translate(621.395 250)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_4941_9161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.957,
    height: 167.49,
    fill: "white",
    transform: "translate(819.822 357.746)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetLogo);
export default __webpack_public_path__ + "static/media/bet-logo.168cac75d7044f35fc17439996274ff2.svg";
export { ForwardRef as ReactComponent };